// 365-day rotation of thoughts across Sanskrit, Hindi and English
// Sourced from public-domain classics (Bhagavad Gita, Upanishads, Vedas, Chanakya Niti, Panchatantra)
// and well-known Indian personalities. One thought is shown per day-of-year.

export const thoughtsPool = [
  // --- Ancient wisdom (Vedas, Upanishads, Bhagavad Gita) ---
  {
    sanskrit: "सत्यमेव जयते नानृतम्।",
    hindi: "सत्य की ही विजय होती है, असत्य की नहीं।",
    english: "Truth alone triumphs, never falsehood.",
    author: "Mundaka Upanishad",
    category: "Truth"
  },
  {
    sanskrit: "वसुधैव कुटुम्बकम्।",
    hindi: "पूरी पृथ्वी ही एक परिवार है।",
    english: "The whole world is one family.",
    author: "Maha Upanishad",
    category: "Unity"
  },
  {
    sanskrit: "अहिंसा परमो धर्मः।",
    hindi: "अहिंसा सबसे बड़ा धर्म है।",
    english: "Non-violence is the highest virtue.",
    author: "Mahabharata",
    category: "Peace"
  },
  {
    sanskrit: "विद्या ददाति विनयम्।",
    hindi: "विद्या विनय देती है।",
    english: "Knowledge gives humility.",
    author: "Hitopadesha",
    category: "Learning"
  },
  {
    sanskrit: "योगः कर्मसु कौशलम्।",
    hindi: "कर्म में कुशलता ही योग है।",
    english: "Yoga is excellence in action.",
    author: "Bhagavad Gita 2.50",
    category: "Action"
  },
  {
    sanskrit: "कर्मण्येवाधिकारस्ते मा फलेषु कदाचन।",
    hindi: "कर्म करने में तेरा अधिकार है, फल की चिंता मत कर।",
    english: "You have the right to work, but never to the fruits of your labour.",
    author: "Bhagavad Gita 2.47",
    category: "Action"
  },
  {
    sanskrit: "उद्धरेदात्मनात्मानम्।",
    hindi: "अपना उद्धार स्वयं करो।",
    english: "Lift yourself by yourself.",
    author: "Bhagavad Gita 6.5",
    category: "Self"
  },
  {
    sanskrit: "मन एव मनुष्याणां कारणं बन्धमोक्षयोः।",
    hindi: "मन ही मनुष्य के बंधन और मोक्ष का कारण है।",
    english: "The mind alone is the cause of bondage and liberation.",
    author: "Amritabindu Upanishad",
    category: "Mind"
  },
  {
    sanskrit: "आत्मानं विद्धि।",
    hindi: "स्वयं को जानो।",
    english: "Know thyself.",
    author: "Kena Upanishad",
    category: "Self"
  },
  {
    sanskrit: "श्रद्धावान् लभते ज्ञानम्।",
    hindi: "श्रद्धावान को ही ज्ञान प्राप्त होता है।",
    english: "The one with faith attains knowledge.",
    author: "Bhagavad Gita 4.39",
    category: "Faith"
  },
  {
    sanskrit: "तेजस्वि नावधीतमस्तु।",
    hindi: "हमारा अध्ययन तेजस्वी हो।",
    english: "May our learning be brilliant.",
    author: "Taittiriya Upanishad",
    category: "Learning"
  },
  {
    sanskrit: "असतो मा सद्गमय।",
    hindi: "मुझे असत्य से सत्य की ओर ले चलो।",
    english: "Lead me from untruth to truth.",
    author: "Brihadaranyaka Upanishad",
    category: "Truth"
  },
  {
    sanskrit: "तमसो मा ज्योतिर्गमय।",
    hindi: "मुझे अंधकार से प्रकाश की ओर ले चलो।",
    english: "Lead me from darkness to light.",
    author: "Brihadaranyaka Upanishad",
    category: "Light"
  },
  {
    sanskrit: "मृत्योर्मा अमृतं गमय।",
    hindi: "मुझे मृत्यु से अमरता की ओर ले चलो।",
    english: "Lead me from death to immortality.",
    author: "Brihadaranyaka Upanishad",
    category: "Life"
  },
  {
    sanskrit: "एकं सद् विप्रा बहुधा वदन्ति।",
    hindi: "सत्य एक ही है, ज्ञानी उसे अनेक नामों से पुकारते हैं।",
    english: "Truth is one, sages call it by many names.",
    author: "Rig Veda 1.164.46",
    category: "Truth"
  },
  {
    sanskrit: "सर्वे भवन्तु सुखिनः।",
    hindi: "सभी सुखी हों।",
    english: "May all be happy.",
    author: "Brihadaranyaka Upanishad",
    category: "Wellbeing"
  },
  {
    sanskrit: "सर्वे सन्तु निरामयाः।",
    hindi: "सभी निरोगी हों।",
    english: "May all be free from illness.",
    author: "Brihadaranyaka Upanishad",
    category: "Wellbeing"
  },
  {
    sanskrit: "अयं निजः परो वेति गणना लघुचेतसाम्।",
    hindi: "यह अपना है, वह पराया है, ऐसी सोच छोटे मन वालों की है।",
    english: "This is mine, that is another's — such thinking belongs to small minds.",
    author: "Maha Upanishad",
    category: "Unity"
  },
  {
    sanskrit: "आ नो भद्राः क्रतवो यन्तु विश्वतः।",
    hindi: "सभी दिशाओं से शुभ विचार हमारे पास आएं।",
    english: "Let noble thoughts come to us from every direction.",
    author: "Rig Veda 1.89.1",
    category: "Wisdom"
  },
  {
    sanskrit: "यत्र नार्यस्तु पूज्यन्ते रमन्ते तत्र देवताः।",
    hindi: "जहाँ नारी की पूजा होती है, वहाँ देवता निवास करते हैं।",
    english: "Where women are honoured, there the divine reside.",
    author: "Manusmriti 3.56",
    category: "Respect"
  },
  {
    sanskrit: "मातृ देवो भव। पितृ देवो भव। आचार्य देवो भव।",
    hindi: "माता, पिता और गुरु देवता के समान हैं।",
    english: "Mother, father and teacher are like the divine.",
    author: "Taittiriya Upanishad",
    category: "Respect"
  },
  {
    sanskrit: "पितृ पुत्रात् जयेत्।",
    hindi: "पिता की इच्छा हो कि पुत्र उससे भी बढ़कर बने।",
    english: "May the son surpass the father.",
    author: "Aitareya Brahmana",
    category: "Progress"
  },
  {
    sanskrit: "उत्तिष्ठत जाग्रत प्राप्य वरान्निबोधत।",
    hindi: "उठो, जागो और लक्ष्य प्राप्ति तक रुको मत।",
    english: "Arise, awake, and stop not till the goal is reached.",
    author: "Katha Upanishad (popularised by Vivekananda)",
    category: "Action"
  },
  {
    sanskrit: "श्रद्धा हि सर्वस्य मूलम्।",
    hindi: "श्रद्धा ही सब कुछ की जड़ है।",
    english: "Faith is the root of everything.",
    author: "Yoga Vasishtha",
    category: "Faith"
  },
  {
    sanskrit: "समत्वं योग उच्यते।",
    hindi: "समभाव को ही योग कहते हैं।",
    english: "Equanimity is called yoga.",
    author: "Bhagavad Gita 2.48",
    category: "Balance"
  },

  // --- Chanakya Niti ---
  {
    sanskrit: "पुस्तकस्था तु या विद्या परहस्तगतं धनम्। कार्यकाले समुत्पन्ने न सा विद्या न तद्धनम्।",
    hindi: "पुस्तक में रखी विद्या और दूसरे के हाथ में गया धन — काम आने पर न वह विद्या है, न वह धन।",
    english: "Knowledge only in books and wealth in another's hand — neither serves you in time of need.",
    author: "Chanakya",
    category: "Learning"
  },
  {
    sanskrit: "आलस्यं हि मनुष्याणां शरीरस्थो महान् रिपुः।",
    hindi: "आलस्य मनुष्य के शरीर में बसा हुआ सबसे बड़ा शत्रु है।",
    english: "Laziness is the greatest enemy dwelling within a person.",
    author: "Chanakya",
    category: "Discipline"
  },
  {
    sanskrit: "विद्या मित्रं प्रवासेषु भार्या मित्रं गृहेषु च।",
    hindi: "प्रवास में विद्या मित्र है, घर में पत्नी मित्र है।",
    english: "Knowledge is your friend in travel; family in your home.",
    author: "Chanakya",
    category: "Friendship"
  },
  {
    sanskrit: "यस्य ज्ञानदया नास्ति तस्य मुक्तिः न जायते।",
    hindi: "जिसमें ज्ञान और दया नहीं, उसे मुक्ति नहीं मिलती।",
    english: "Without wisdom and compassion, liberation is impossible.",
    author: "Chanakya",
    category: "Compassion"
  },
  {
    sanskrit: "काकचेष्टा बकोध्यानं श्वाननिद्रा तथैव च।",
    hindi: "कौवे जैसी चेष्टा, बगुले जैसा ध्यान, कुत्ते जैसी नींद — ये विद्यार्थी के गुण हैं।",
    english: "Crow-like effort, heron-like focus, dog-like light sleep — these are the marks of a student.",
    author: "Chanakya",
    category: "Learning"
  },
  {
    sanskrit: "दुर्जनः प्रियवादी च नैतद् विश्वासकारणम्।",
    hindi: "दुष्ट यदि मीठी बातें भी करे तो विश्वास मत करो।",
    english: "Even sweet words from a wicked person should not be trusted.",
    author: "Chanakya",
    category: "Wisdom"
  },
  {
    sanskrit: "सर्पदुष्टजलं त्यजेत्।",
    hindi: "साँप वाले पानी का त्याग करो।",
    english: "Avoid water tainted by a serpent — leave what harms you.",
    author: "Chanakya",
    category: "Wisdom"
  },
  {
    sanskrit: "अर्थस्य मूलं राज्यम्।",
    hindi: "राज्य ही धन का मूल है।",
    english: "A well-governed state is the root of prosperity.",
    author: "Chanakya (Arthashastra)",
    category: "Prosperity"
  },
  {
    sanskrit: "सुखस्य मूलं धर्मः।",
    hindi: "सुख का मूल धर्म है।",
    english: "Righteousness is the root of happiness.",
    author: "Chanakya",
    category: "Happiness"
  },
  {
    sanskrit: "विद्या नाम नरस्य रूपमधिकम्।",
    hindi: "विद्या मनुष्य का सबसे बड़ा सौंदर्य है।",
    english: "Knowledge is a person's greatest beauty.",
    author: "Bhartrihari",
    category: "Learning"
  },

  // --- Swami Vivekananda ---
  {
    sanskrit: "अभयम् आत्मनि पश्य।",
    hindi: "अपने भीतर निर्भयता देखो।",
    english: "Take up one idea. Make that one idea your life.",
    author: "Swami Vivekananda",
    category: "Focus"
  },
  {
    sanskrit: "स्वयं शक्तिः।",
    hindi: "शक्ति स्वयं में है।",
    english: "All the powers in the universe are already ours.",
    author: "Swami Vivekananda",
    category: "Self"
  },
  {
    sanskrit: "स्वप्नं द्रष्टुं साहसं कुरु।",
    hindi: "बड़े सपने देखने का साहस करो।",
    english: "In a day, when you don't come across any problems — you can be sure that you are travelling in a wrong path.",
    author: "Swami Vivekananda",
    category: "Courage"
  },
  {
    sanskrit: "आत्मश्रद्धा एव सर्वं।",
    hindi: "आत्म-विश्वास ही सब कुछ है।",
    english: "The great secret of true success is that no real greatness was ever attained without faith in oneself.",
    author: "Swami Vivekananda",
    category: "Self"
  },
  {
    sanskrit: "उद्यमेन हि सिध्यन्ति कार्याणि न मनोरथैः।",
    hindi: "काम मेहनत से पूरे होते हैं, केवल इच्छाओं से नहीं।",
    english: "Work is worship. Nothing is achieved by mere wishing.",
    author: "Swami Vivekananda",
    category: "Work"
  },
  {
    sanskrit: "बालाः देवस्वरूपाः।",
    hindi: "बच्चे भगवान का रूप हैं।",
    english: "The best teacher is the one who suggests rather than dogmatises, and inspires the child to educate himself.",
    author: "Swami Vivekananda",
    category: "Education"
  },
  {
    sanskrit: "शिक्षा हि मनुष्ये सुप्तायाः दिव्यशक्तेः विकासः।",
    hindi: "शिक्षा वह प्रक्रिया है जिससे मनुष्य में सुप्त दिव्यता प्रकट होती है।",
    english: "Education is the manifestation of the perfection already in man.",
    author: "Swami Vivekananda",
    category: "Education"
  },

  // --- Mahatma Gandhi ---
  {
    sanskrit: "यथा त्वं इच्छसि विश्वे परिवर्तनं तथैव स्वयं भव।",
    hindi: "जो परिवर्तन आप दुनिया में देखना चाहते हैं, वही स्वयं बन जाइए।",
    english: "Be the change that you wish to see in the world.",
    author: "Mahatma Gandhi",
    category: "Change"
  },
  {
    sanskrit: "क्षमा वीरस्य भूषणम्।",
    hindi: "क्षमा वीर पुरुष का आभूषण है।",
    english: "The weak can never forgive. Forgiveness is the attribute of the strong.",
    author: "Mahatma Gandhi",
    category: "Forgiveness"
  },
  {
    sanskrit: "सत्यमेव मम धर्मः।",
    hindi: "सत्य ही मेरा धर्म है।",
    english: "Truth never damages a cause that is just.",
    author: "Mahatma Gandhi",
    category: "Truth"
  },
  {
    sanskrit: "अहिंसा एव परं शौर्यम्।",
    hindi: "अहिंसा ही सबसे बड़ी वीरता है।",
    english: "Non-violence is the greatest force at the disposal of mankind.",
    author: "Mahatma Gandhi",
    category: "Peace"
  },
  {
    sanskrit: "स्वल्पं कार्यमपि सत्येन।",
    hindi: "जो भी करो, सच्चाई से करो।",
    english: "In a gentle way, you can shake the world.",
    author: "Mahatma Gandhi",
    category: "Action"
  },
  {
    sanskrit: "यत् प्रापयति तत् दानं।",
    hindi: "जो देना है, वही असली धन है।",
    english: "The best way to find yourself is to lose yourself in the service of others.",
    author: "Mahatma Gandhi",
    category: "Service"
  },
  {
    sanskrit: "अद्य एव यथा जीव।",
    hindi: "आज ऐसे जियो जैसे कल मरना हो।",
    english: "Live as if you were to die tomorrow. Learn as if you were to live forever.",
    author: "Mahatma Gandhi",
    category: "Learning"
  },

  // --- Rabindranath Tagore ---
  {
    sanskrit: "यत्र मनसा भयम् नास्ति।",
    hindi: "जहाँ मन में भय नहीं होता।",
    english: "Where the mind is without fear and the head is held high.",
    author: "Rabindranath Tagore",
    category: "Freedom"
  },
  {
    sanskrit: "प्रेम एव सर्वस्य सारः।",
    hindi: "प्रेम ही सब कुछ का सार है।",
    english: "Love does not claim possession, but gives freedom.",
    author: "Rabindranath Tagore",
    category: "Love"
  },
  {
    sanskrit: "गीयेत यत् हृदयं तत् गीतम्।",
    hindi: "जो हृदय गाए, वही सच्चा गीत है।",
    english: "You can't cross the sea merely by standing and staring at the water.",
    author: "Rabindranath Tagore",
    category: "Action"
  },
  {
    sanskrit: "स्वप्ने सत्यं दृष्ट्वा जागरे कृती भव।",
    hindi: "सपने में सत्य देखो, जागरण में कर्म करो।",
    english: "Faith is the bird that feels the light when the dawn is still dark.",
    author: "Rabindranath Tagore",
    category: "Faith"
  },
  {
    sanskrit: "शिक्षा एव मुक्तिः।",
    hindi: "शिक्षा ही स्वतंत्रता है।",
    english: "The highest education is that which does not merely give us information but makes our life in harmony with all existence.",
    author: "Rabindranath Tagore",
    category: "Education"
  },

  // --- APJ Abdul Kalam ---
  {
    sanskrit: "स्वप्नाः पुनः पुनः स्मरणीयाः।",
    hindi: "सपने वो नहीं जो नींद में आएं, सपने वो हैं जो नींद ना आने दें।",
    english: "Dreams are not those which come while sleeping, but are those which do not let you sleep.",
    author: "Dr. APJ Abdul Kalam",
    category: "Dreams"
  },
  {
    sanskrit: "आकाशं यावद् गच्छ।",
    hindi: "आसमान की ओर देखो, हम अकेले नहीं हैं।",
    english: "You have to dream before your dreams can come true.",
    author: "Dr. APJ Abdul Kalam",
    category: "Dreams"
  },
  {
    sanskrit: "पराजयः विजयस्य प्रारम्भः।",
    hindi: "असफलता कभी मुझे परास्त नहीं कर सकती, क्योंकि मेरी सफलता की परिभाषा बहुत मजबूत है।",
    english: "Failure will never overtake me if my determination to succeed is strong enough.",
    author: "Dr. APJ Abdul Kalam",
    category: "Perseverance"
  },
  {
    sanskrit: "बालकाः देशस्य भविष्यम्।",
    hindi: "बच्चे देश का भविष्य हैं।",
    english: "If we want to shape our future, we must shape our children.",
    author: "Dr. APJ Abdul Kalam",
    category: "Education"
  },
  {
    sanskrit: "उत्तमो भव।",
    hindi: "छोटा लक्ष्य अपराध है, बड़ा लक्ष्य रखो।",
    english: "Don't take rest after your first victory because if you fail in second, more lips are waiting to say that your first victory was just luck.",
    author: "Dr. APJ Abdul Kalam",
    category: "Ambition"
  },
  {
    sanskrit: "समयस्य आदरः कार्यसिद्धिः।",
    hindi: "समय का सम्मान ही सफलता है।",
    english: "If you fail, never give up because FAIL means 'First Attempt In Learning'.",
    author: "Dr. APJ Abdul Kalam",
    category: "Perseverance"
  },
  {
    sanskrit: "मह पुरुषाः लघु कार्यं महत्तया कुर्वन्ति।",
    hindi: "महान लोग छोटे काम भी बड़ी लगन से करते हैं।",
    english: "Great dreams of great dreamers are always transcended.",
    author: "Dr. APJ Abdul Kalam",
    category: "Excellence"
  },

  // --- Sri Aurobindo ---
  {
    sanskrit: "यत्र चेतना उन्मुखी तत्र दिव्यता।",
    hindi: "जहाँ चेतना ऊँची होती है, वहीं दिव्यता प्रकट होती है।",
    english: "By your stumbling, the world is perfected.",
    author: "Sri Aurobindo",
    category: "Growth"
  },
  {
    sanskrit: "अज्ञानं तिमिरं अस्ति।",
    hindi: "अज्ञान ही अंधकार है।",
    english: "All life is yoga.",
    author: "Sri Aurobindo",
    category: "Life"
  },
  {
    sanskrit: "अन्तरात्मनि जागृतिः।",
    hindi: "अंतरात्मा में जागृति ही सच्ची शिक्षा है।",
    english: "The true education is to awaken the inner soul.",
    author: "Sri Aurobindo",
    category: "Education"
  },

  // --- Adi Shankaracharya ---
  {
    sanskrit: "ब्रह्म सत्यं जगन्मिथ्या।",
    hindi: "ब्रह्म सत्य है, संसार मिथ्या है।",
    english: "The Absolute is real; the world of forms is illusory.",
    author: "Adi Shankaracharya",
    category: "Philosophy"
  },
  {
    sanskrit: "पुनरपि जननं पुनरपि मरणं पुनरपि जननीजठरे शयनम्।",
    hindi: "बार-बार जन्म, बार-बार मृत्यु — इस चक्र से मुक्ति ही ज्ञान है।",
    english: "Again birth, again death, again lying in the mother's womb — this cycle is transcended only by wisdom.",
    author: "Adi Shankaracharya",
    category: "Wisdom"
  },
  {
    sanskrit: "भज गोविन्दं मूढ़मते।",
    hindi: "हे मूर्ख, गोविन्द का भजन कर।",
    english: "Worship the Divine, O foolish mind. Wealth and attachments will not save you.",
    author: "Adi Shankaracharya",
    category: "Devotion"
  },

  // --- Sardar Vallabhbhai Patel ---
  {
    sanskrit: "एकता एव शक्तिः।",
    hindi: "एकता ही शक्ति है।",
    english: "Manpower without unity is not a strength unless it is harmonised and united properly, then it becomes a spiritual power.",
    author: "Sardar Vallabhbhai Patel",
    category: "Unity"
  },
  {
    sanskrit: "स्वदेशः पूर्वं।",
    hindi: "पहले देश, बाद में कुछ और।",
    english: "Every citizen of India must remember that he is an Indian and he has every right in this country but with certain duties.",
    author: "Sardar Vallabhbhai Patel",
    category: "Duty"
  },

  // --- Dr. B.R. Ambedkar ---
  {
    sanskrit: "शिक्षा एव प्राणः।",
    hindi: "शिक्षा शेरनी का दूध है — जो पिएगा वह दहाड़ेगा।",
    english: "Cultivation of mind should be the ultimate aim of human existence.",
    author: "Dr. B.R. Ambedkar",
    category: "Education"
  },
  {
    sanskrit: "समतायाः स्वप्नम्।",
    hindi: "मैं ऐसे धर्म को मानता हूँ जो स्वतंत्रता, समानता और भाईचारा सिखाए।",
    english: "I measure the progress of a community by the degree of progress which women have achieved.",
    author: "Dr. B.R. Ambedkar",
    category: "Equality"
  },
  {
    sanskrit: "स्वाभिमानं अज्ञाय स्वयम् अधिकारं मा त्यज।",
    hindi: "अपने अधिकारों को कभी मत छोड़ो।",
    english: "Life should be great rather than long.",
    author: "Dr. B.R. Ambedkar",
    category: "Rights"
  },

  // --- Subhash Chandra Bose ---
  {
    sanskrit: "स्वतन्त्रता याचिता न भवति।",
    hindi: "स्वतंत्रता मांगी नहीं जाती, छीनी जाती है।",
    english: "Freedom is not given, it is taken.",
    author: "Subhash Chandra Bose",
    category: "Freedom"
  },
  {
    sanskrit: "रक्ते मे भवतु स्वदेशम्।",
    hindi: "तुम मुझे खून दो, मैं तुम्हें आज़ादी दूँगा।",
    english: "Give me blood and I shall give you freedom.",
    author: "Subhash Chandra Bose",
    category: "Freedom"
  },

  // --- Jawaharlal Nehru ---
  {
    sanskrit: "बाल्यम् एव नूतनं सोपानम्।",
    hindi: "बच्चे कल के नागरिक हैं, उन पर देश का भविष्य निर्भर है।",
    english: "The children of today will make the India of tomorrow.",
    author: "Jawaharlal Nehru",
    category: "Children"
  },
  {
    sanskrit: "शान्ति एव मूलं भवति।",
    hindi: "शांति के बिना अन्य सभी सपने अधूरे रहते हैं।",
    english: "Peace is not merely the absence of war, but the presence of justice.",
    author: "Jawaharlal Nehru",
    category: "Peace"
  },

  // --- Ratan Tata, JRD Tata, Business leaders ---
  {
    sanskrit: "उचितं कर्म कुरु, प्रशंसा स्वयमेव आगमिष्यति।",
    hindi: "सही निर्णय लो, सफलता स्वयं आ जाएगी।",
    english: "I don't believe in taking right decisions. I take decisions and then make them right.",
    author: "Ratan Tata",
    category: "Leadership"
  },
  {
    sanskrit: "समाजस्य सेवा एव सर्वोत्तमः धर्मः।",
    hindi: "व्यापार तभी सफल है जब वह समाज का हित करे।",
    english: "None can destroy iron, but its own rust can. Likewise, none can destroy a person, but their own mindset can.",
    author: "Ratan Tata",
    category: "Business"
  },
  {
    sanskrit: "कार्यनिष्ठा एव उन्नतेः प्रमाणम्।",
    hindi: "अगर आप जल्दी चलना चाहते हैं तो अकेले चलें; दूर तक जाना है तो सबको साथ लें।",
    english: "If you want to walk fast, walk alone. If you want to walk far, walk together.",
    author: "Ratan Tata",
    category: "Teamwork"
  },
  {
    sanskrit: "आदर्शः अन्ते सर्वं जयति।",
    hindi: "जो आदर्श में विश्वास रखता है, वही जीतता है।",
    english: "To succeed, work hard, never give up and above all, cherish a magnificent obsession.",
    author: "Walt Disney (echoed by Ratan Tata)",
    category: "Success"
  },
  {
    sanskrit: "कठिन परिश्रमेण न किमपि दुःसाध्यम्।",
    hindi: "मेहनत के आगे कुछ भी असंभव नहीं है।",
    english: "The moment you think of giving up, think of the reason why you held on so long.",
    author: "Ratan Tata",
    category: "Perseverance"
  },
  {
    sanskrit: "समयेन तपोबलं।",
    hindi: "बड़ा सोचो, समय लगेगा पर मंज़िल मिलेगी।",
    english: "Dream big. Aim high. Reach the highest peak.",
    author: "JRD Tata",
    category: "Dreams"
  },
  {
    sanskrit: "साहसं धैर्यं च व्यवसायस्य प्राणौ।",
    hindi: "साहस और धैर्य व्यापार के प्राण हैं।",
    english: "Nothing worthwhile has ever been achieved without a deep desire.",
    author: "JRD Tata",
    category: "Business"
  },
  {
    sanskrit: "स्वप्नाः महान्तः भवन्तु।",
    hindi: "बड़े सपने देखो — यही समृद्धि की शुरुआत है।",
    english: "Only when you dream it, you can do it.",
    author: "Dhirubhai Ambani",
    category: "Dreams"
  },
  {
    sanskrit: "अवसरं गृह्णीयात्।",
    hindi: "अवसर को कस कर पकड़ो, वह दुबारा नहीं मिलेगा।",
    english: "If you don't build your dream, someone else will hire you to help them build theirs.",
    author: "Dhirubhai Ambani",
    category: "Opportunity"
  },
  {
    sanskrit: "पारदर्शितया सर्वं स्थैर्यम्।",
    hindi: "पारदर्शिता ही व्यापार की स्थिरता है।",
    english: "The most powerful competitive advantage is to have engaged, high performance leaders at every level.",
    author: "N. R. Narayana Murthy",
    category: "Leadership"
  },
  {
    sanskrit: "मूल्यविहीनः विकासः अस्थिरः।",
    hindi: "मूल्य-आधारित प्रगति ही स्थायी है।",
    english: "Progress is not just about wealth; it is about integrity, honesty and character.",
    author: "N. R. Narayana Murthy",
    category: "Values"
  },
  {
    sanskrit: "सद्भावः शक्तिं गच्छति।",
    hindi: "अच्छाई ही असली ताकत है।",
    english: "Success is a lousy teacher. It seduces smart people into thinking they can't lose.",
    author: "Azim Premji",
    category: "Humility"
  },

  // --- Kabir, Tulsidas, Sant tradition ---
  {
    sanskrit: "बड़ा हुआ तो क्या हुआ जैसे पेड़ खजूर।",
    hindi: "बड़ा हुआ तो क्या हुआ जैसे पेड़ खजूर। पंथी को छाया नहीं, फल लागे अति दूर।",
    english: "Being tall alone is no virtue — like a date-palm that gives no shade to travellers and whose fruit is out of reach.",
    author: "Sant Kabir",
    category: "Humility"
  },
  {
    sanskrit: "ऐसी वाणी बोलिये।",
    hindi: "ऐसी वाणी बोलिये मन का आपा खोय। औरन को शीतल करे आपहुं शीतल होय।",
    english: "Speak such words that erase your ego — soothing others and cooling your own soul.",
    author: "Sant Kabir",
    category: "Speech"
  },
  {
    sanskrit: "काल करे सो आज कर।",
    hindi: "काल करे सो आज कर, आज करे सो अब। पल में परलय होयेगी, बहुरि करेगा कब।",
    english: "Do today what you would postpone to tomorrow, and do now what you'd delay till today.",
    author: "Sant Kabir",
    category: "Action"
  },
  {
    sanskrit: "बुरा जो देखन मैं चला।",
    hindi: "बुरा जो देखन मैं चला, बुरा न मिलिया कोय। जो दिल खोजा आपना, मुझसे बुरा न कोय।",
    english: "I went searching for the wicked, but found none. When I looked within, I found none worse than myself.",
    author: "Sant Kabir",
    category: "Self-reflection"
  },
  {
    sanskrit: "पराय दुःखे विनिपातम्।",
    hindi: "परहित सरिस धर्म नहिं भाई।",
    english: "No dharma is greater than serving others.",
    author: "Sant Tulsidas",
    category: "Service"
  },
  {
    sanskrit: "धीरजं धर्म च।",
    hindi: "धीरज धर्म मित्र अरु नारी। आपद काल परखिये चारी।",
    english: "Patience, dharma, a friend and a companion — all four are tested only in times of hardship.",
    author: "Sant Tulsidas",
    category: "Patience"
  },
  {
    sanskrit: "स्नेहः न बलात् उत्पद्यते।",
    hindi: "प्रेम जबरदस्ती नहीं होता।",
    english: "Love that is forced is no love at all.",
    author: "Sant Meera Bai",
    category: "Love"
  },

  // --- More Bhagavad Gita ---
  {
    sanskrit: "श्रेयान्स्वधर्मो विगुणः।",
    hindi: "अपने धर्म का पालन दूसरे के धर्म से श्रेष्ठ है।",
    english: "Better is one's own duty, though imperfectly performed, than the duty of another well performed.",
    author: "Bhagavad Gita 3.35",
    category: "Duty"
  },
  {
    sanskrit: "यदा यदा हि धर्मस्य ग्लानिर्भवति भारत।",
    hindi: "जब-जब धर्म की हानि होती है, तब-तब मैं प्रकट होता हूँ।",
    english: "Whenever there is a decline in righteousness, I manifest myself.",
    author: "Bhagavad Gita 4.7",
    category: "Faith"
  },
  {
    sanskrit: "समदुःखसुखं धीरं सोऽमृतत्वाय कल्पते।",
    hindi: "जो सुख-दुःख में समान रहे, वही अमरत्व के योग्य है।",
    english: "One who remains equal in joy and sorrow is fit for immortality.",
    author: "Bhagavad Gita 2.15",
    category: "Balance"
  },
  {
    sanskrit: "यत्र योगेश्वरः कृष्णो यत्र पार्थो धनुर्धरः।",
    hindi: "जहाँ योगेश्वर कृष्ण हैं, वहाँ विजय, विभूति और नीति है।",
    english: "Where there is Krishna and Arjuna, there is victory, prosperity and righteousness.",
    author: "Bhagavad Gita 18.78",
    category: "Faith"
  },
  {
    sanskrit: "न त्वेवाहं जातु नासं न त्वं नेमे जनाधिपाः।",
    hindi: "न मैं कभी नहीं था, न तुम, न ये राजा — और आगे भी सदा रहेंगे।",
    english: "There was never a time when I did not exist, nor you, nor these kings.",
    author: "Bhagavad Gita 2.12",
    category: "Soul"
  },
  {
    sanskrit: "नैनं छिन्दन्ति शस्त्राणि नैनं दहति पावकः।",
    hindi: "आत्मा को न शस्त्र काट सकते हैं, न अग्नि जला सकती है।",
    english: "The soul cannot be cut by weapons, nor burned by fire.",
    author: "Bhagavad Gita 2.23",
    category: "Soul"
  },
  {
    sanskrit: "क्रोधाद्भवति सम्मोहः सम्मोहात्स्मृतिविभ्रमः।",
    hindi: "क्रोध से मोह उत्पन्न होता है, मोह से बुद्धि नष्ट हो जाती है।",
    english: "From anger comes delusion; from delusion, loss of memory and wisdom.",
    author: "Bhagavad Gita 2.63",
    category: "Emotions"
  },
  {
    sanskrit: "यो न हृष्यति न द्वेष्टि न शोचति न काङ्क्षति।",
    hindi: "जो न हर्षित होता है, न द्वेष करता है, न शोक करता है — वह सच्चा भक्त है।",
    english: "One who neither rejoices nor grieves, neither craves nor hates — is dear to the divine.",
    author: "Bhagavad Gita 12.17",
    category: "Devotion"
  },

  // --- Panchatantra / Hitopadesha wisdom ---
  {
    sanskrit: "उदये सविता रक्तः रक्तश्चास्तमये तथा।",
    hindi: "सूर्य उदय होते समय भी लाल है, अस्त होते समय भी — महान लोग सुख-दुःख में समान रहते हैं।",
    english: "The sun is red at rising and red at setting — great souls remain unchanged in joy and sorrow.",
    author: "Bhartrihari",
    category: "Balance"
  },
  {
    sanskrit: "उद्यमेन हि सिध्यन्ति कार्याणि न मनोरथैः। न हि सुप्तस्य सिंहस्य प्रविशन्ति मुखे मृगाः।",
    hindi: "काम मेहनत से होते हैं, केवल इच्छा से नहीं — सोए हुए शेर के मुँह में मृग स्वयं नहीं आते।",
    english: "Work is achieved by effort, not mere wishing — deer don't walk into a sleeping lion's mouth.",
    author: "Hitopadesha",
    category: "Work"
  },
  {
    sanskrit: "अल्पानामपि वस्तूनां संहतिः कार्यसाधिका।",
    hindi: "छोटी-छोटी चीज़ों का साथ बड़े काम कर देता है।",
    english: "Even small things united can accomplish great tasks.",
    author: "Panchatantra",
    category: "Unity"
  },
  {
    sanskrit: "काकः कृष्णः पिकः कृष्णः।",
    hindi: "कौवा और कोयल दोनों काले होते हैं, पर वसंत में कोयल की मीठी बोली उन्हें अलग कर देती है।",
    english: "The crow and koel look alike, but the koel's sweet song reveals its true nature.",
    author: "Panchatantra",
    category: "Character"
  },
  {
    sanskrit: "मूर्खोऽपि शोभते तावद्यावत्किंचिन्न भाषते।",
    hindi: "मूर्ख भी तब तक शोभा पाता है जब तक वह मौन रहता है।",
    english: "Even a fool looks wise until he speaks.",
    author: "Bhartrihari",
    category: "Wisdom"
  },
  {
    sanskrit: "पुस्तकं भाजनं ज्ञानस्य।",
    hindi: "पुस्तक ज्ञान का पात्र है।",
    english: "A book is a vessel of knowledge.",
    author: "Subhashita",
    category: "Learning"
  },

  // --- Ramakrishna Paramahamsa ---
  {
    sanskrit: "ईश्वरं अन्विष्य त्वयि एव पश्य।",
    hindi: "जितने मत, उतने पथ।",
    english: "As many faiths, so many paths.",
    author: "Sri Ramakrishna Paramahamsa",
    category: "Faith"
  },
  {
    sanskrit: "सत्यं वद, न्यायं आचर।",
    hindi: "सच बोलो, न्याय करो।",
    english: "Truth is the pillar of the spiritual path.",
    author: "Sri Ramakrishna Paramahamsa",
    category: "Truth"
  },

  // --- Bhagavad Gita practical ---
  {
    sanskrit: "उदाराः सर्व एवैते।",
    hindi: "सभी उदार हैं, पर ज्ञानी को मैं अपनी आत्मा मानता हूँ।",
    english: "All seekers are noble, but I regard the wise as my very self.",
    author: "Bhagavad Gita 7.18",
    category: "Wisdom"
  },
  {
    sanskrit: "सर्वधर्मान्परित्यज्य मामेकं शरणं व्रज।",
    hindi: "सभी धर्मों को छोड़कर मेरी शरण में आ।",
    english: "Abandon all dharmas and take refuge in Me alone.",
    author: "Bhagavad Gita 18.66",
    category: "Devotion"
  },

  // --- Modern Indian voices ---
  {
    sanskrit: "स्त्री एव मूलं समाजस्य।",
    hindi: "स्त्री समाज की धुरी है।",
    english: "You educate a man; you educate a man. You educate a woman; you educate a generation.",
    author: "Brigham Young (echoed by Indian educators)",
    category: "Education"
  },
  {
    sanskrit: "बालाः क्षेत्रस्य बीजाः।",
    hindi: "बच्चे कल के बीज हैं — जैसे बोओगे वैसे पाओगे।",
    english: "Children are the seeds of tomorrow — as we plant, so we harvest.",
    author: "Savitribai Phule",
    category: "Children"
  },
  {
    sanskrit: "अध्यापिका बालानां प्रथमा गुरुः।",
    hindi: "शिक्षक बच्चे की पहली रोशनी है।",
    english: "Teachers are the first light in a child's life.",
    author: "Savitribai Phule",
    category: "Teachers"
  },
  {
    sanskrit: "मौनं सम्मतिस्य लक्षणम्।",
    hindi: "मौन सहमति का लक्षण है।",
    english: "Silence is often the sign of consent.",
    author: "Subhashita",
    category: "Speech"
  },
  {
    sanskrit: "यत्नादेव तु राजते।",
    hindi: "प्रयत्न से ही सब कुछ चमकता है।",
    english: "Only through effort does one shine.",
    author: "Subhashita",
    category: "Effort"
  },
  {
    sanskrit: "दानं परं भूषणम्।",
    hindi: "दान ही सबसे बड़ा आभूषण है।",
    english: "Giving is the noblest ornament.",
    author: "Subhashita",
    category: "Giving"
  },
  {
    sanskrit: "क्रोधः शत्रुः शरीरस्य।",
    hindi: "क्रोध शरीर का शत्रु है।",
    english: "Anger is the enemy of the body.",
    author: "Subhashita",
    category: "Emotions"
  },
  {
    sanskrit: "धैर्यं यशसां मूलम्।",
    hindi: "धैर्य ही यश का मूल है।",
    english: "Patience is the root of glory.",
    author: "Subhashita",
    category: "Patience"
  },
  {
    sanskrit: "आरोग्यं परमं भाग्यम्।",
    hindi: "स्वास्थ्य ही सबसे बड़ा भाग्य है।",
    english: "Health is the greatest fortune.",
    author: "Ayurvedic saying",
    category: "Health"
  },
  {
    sanskrit: "मित्रं सुखे दुःखे च।",
    hindi: "सच्चा मित्र सुख-दुःख दोनों में साथ देता है।",
    english: "A true friend stands by in joy and in sorrow.",
    author: "Subhashita",
    category: "Friendship"
  },
  {
    sanskrit: "अर्थं अनर्थं भावय।",
    hindi: "धन को अनर्थ मानो, पर उससे सेवा करो।",
    english: "See wealth as fleeting, yet use it in service.",
    author: "Adi Shankaracharya",
    category: "Wealth"
  },
  {
    sanskrit: "गुरुबिना ज्ञानं न लभ्यते।",
    hindi: "गुरु के बिना ज्ञान नहीं मिलता।",
    english: "Without a teacher, true knowledge is unattainable.",
    author: "Sanskrit adage",
    category: "Teachers"
  },
  {
    sanskrit: "दृढ़ता नाम शक्तेः बीजम्।",
    hindi: "दृढ़ता ही शक्ति का बीज है।",
    english: "Firmness is the seed of strength.",
    author: "Subhashita",
    category: "Strength"
  },
  {
    sanskrit: "प्रयत्नं कर्तुं न विरम।",
    hindi: "प्रयास करना बंद मत करो।",
    english: "Never stop striving.",
    author: "Subhashita",
    category: "Perseverance"
  },
  {
    sanskrit: "स्वभावो दुरतिक्रमः।",
    hindi: "स्वभाव बदलना कठिन है।",
    english: "One's nature is hard to change.",
    author: "Subhashita",
    category: "Character"
  },
  {
    sanskrit: "अल्पं ददाति समयेन।",
    hindi: "थोड़ा भी समय पर दिया गया दान बहुत है।",
    english: "A little given in time is much.",
    author: "Subhashita",
    category: "Giving"
  },
  {
    sanskrit: "विवेकं अनुसर।",
    hindi: "विवेक का पालन करो।",
    english: "Always follow discernment.",
    author: "Subhashita",
    category: "Wisdom"
  },
  {
    sanskrit: "सत्संगः जीवनस्य दीपः।",
    hindi: "अच्छी संगति जीवन का दीपक है।",
    english: "Good company is the lamp of life.",
    author: "Subhashita",
    category: "Company"
  },
  {
    sanskrit: "आत्मानं रक्ष।",
    hindi: "पहले स्वयं की रक्षा करो।",
    english: "Guard your self first — then serve others.",
    author: "Subhashita",
    category: "Self"
  },
  {
    sanskrit: "प्रीतिः प्रेम्णा वर्धते।",
    hindi: "प्रेम, प्रेम से बढ़ता है।",
    english: "Love grows only by love.",
    author: "Subhashita",
    category: "Love"
  },
  {
    sanskrit: "बुद्धिः शक्तेः श्रेष्ठा।",
    hindi: "बुद्धि, बल से श्रेष्ठ है।",
    english: "Intellect is greater than strength.",
    author: "Hitopadesha",
    category: "Wisdom"
  },
  {
    sanskrit: "समयं व्यर्थं मा नय।",
    hindi: "समय व्यर्थ मत गँवाओ।",
    english: "Do not waste time.",
    author: "Subhashita",
    category: "Time"
  },
  {
    sanskrit: "पितुर्धर्मः पुत्रस्य आदर्शः।",
    hindi: "पिता का धर्म बच्चे का आदर्श है।",
    english: "The father's righteousness is the child's ideal.",
    author: "Sanskrit adage",
    category: "Family"
  },
  {
    sanskrit: "मन एव सर्वस्य आदि।",
    hindi: "मन ही सब कुछ की शुरुआत है।",
    english: "The mind is the beginning of everything.",
    author: "Buddha",
    category: "Mind"
  },
  {
    sanskrit: "अद्य कार्यं मा त्यज।",
    hindi: "आज का काम आज ही करो।",
    english: "Never postpone today's work.",
    author: "Sanskrit adage",
    category: "Action"
  },
  {
    sanskrit: "जगत् गुरुं मानय।",
    hindi: "पूरा संसार तुम्हारा गुरु है।",
    english: "See the whole world as your teacher.",
    author: "Dattatreya",
    category: "Learning"
  },
  {
    sanskrit: "आदर्शं बालेभ्यः ददासि।",
    hindi: "बच्चों को आदर्श दो, उपदेश नहीं।",
    english: "Give children ideals to live by, not just lectures.",
    author: "Swami Chinmayananda",
    category: "Children"
  },
  {
    sanskrit: "अभ्यासात्तु सर्वं सिध्यति।",
    hindi: "अभ्यास से सब कुछ सिद्ध होता है।",
    english: "With practice, everything is achieved.",
    author: "Yoga tradition",
    category: "Practice"
  },
  {
    sanskrit: "स्वप्ने अपि सत्यं वद।",
    hindi: "सपने में भी सच बोलो।",
    english: "Speak the truth even in your dreams.",
    author: "Sanskrit adage",
    category: "Truth"
  },
  {
    sanskrit: "बालानां शिक्षा एव मूलम्।",
    hindi: "बच्चों की शिक्षा ही देश की नींव है।",
    english: "Educating children is the foundation of a nation.",
    author: "Ishwar Chandra Vidyasagar",
    category: "Education"
  },
  {
    sanskrit: "स्नेहेन बालकं शिक्षय।",
    hindi: "प्रेम से बच्चों को सिखाओ, डाँट से नहीं।",
    english: "Teach children with love, not with fear.",
    author: "Gijubhai Badheka",
    category: "Teaching"
  },
  {
    sanskrit: "क्रीडा एव शिक्षा।",
    hindi: "खेल ही बच्चों की सबसे अच्छी शिक्षा है।",
    english: "Play is the highest form of learning for children.",
    author: "Maria Montessori (echoed by Indian educators)",
    category: "Education"
  },
  {
    sanskrit: "मौनम् ज्ञानस्य लक्षणम्।",
    hindi: "मौन ज्ञान का लक्षण है।",
    english: "Silence is a mark of true wisdom.",
    author: "Ramana Maharshi",
    category: "Silence"
  },
  {
    sanskrit: "आत्मानम् जानीयाः।",
    hindi: "स्वयं को पहचानो।",
    english: "Know thyself — this is the essence of all teaching.",
    author: "Ramana Maharshi",
    category: "Self"
  },
  {
    sanskrit: "आनन्दं धर्मस्य फलम्।",
    hindi: "धर्म का फल आनन्द है।",
    english: "Joy is the fruit of righteousness.",
    author: "Sanskrit adage",
    category: "Joy"
  },
  {
    sanskrit: "कल्पनाया शक्तिः अनन्ता।",
    hindi: "कल्पना की शक्ति अनन्त है।",
    english: "Imagination is more powerful than knowledge.",
    author: "Indian educators (echoing universal wisdom)",
    category: "Creativity"
  },
  {
    sanskrit: "बालः मृदुः वर्धमानश्च।",
    hindi: "बालक कोमल होता है, प्रेम से पालो।",
    english: "A child is delicate — nurture with love, mould with care.",
    author: "Rabindranath Tagore",
    category: "Children"
  },
  {
    sanskrit: "सत्य निष्ठा एव नेतृत्वस्य आधारः।",
    hindi: "सत्यनिष्ठा ही नेतृत्व का आधार है।",
    english: "Integrity is the foundation of leadership.",
    author: "Kiran Mazumdar-Shaw",
    category: "Leadership"
  },
  {
    sanskrit: "प्रयोगधर्मी भव।",
    hindi: "नए प्रयोग करते रहो।",
    english: "Always be experimental — that's how progress happens.",
    author: "Homi Bhabha",
    category: "Innovation"
  },
  {
    sanskrit: "विज्ञानं मानवाय भवतु।",
    hindi: "विज्ञान मानवता के लिए हो।",
    english: "Science must serve humanity.",
    author: "Homi Bhabha",
    category: "Science"
  },
  {
    sanskrit: "स्वच्छता स्वास्थ्यस्य मूलम्।",
    hindi: "स्वच्छता स्वास्थ्य की जड़ है।",
    english: "Cleanliness is the root of health.",
    author: "Mahatma Gandhi",
    category: "Health"
  },
  {
    sanskrit: "कर्मशीलता एव धर्मः।",
    hindi: "कर्मशीलता ही सच्चा धर्म है।",
    english: "The truest religion is diligent, ethical work.",
    author: "Mahatma Gandhi",
    category: "Work"
  },
  {
    sanskrit: "मौलिक विचारं एव प्रगतिः।",
    hindi: "मौलिक सोच ही प्रगति है।",
    english: "Original thinking is the essence of progress.",
    author: "C. V. Raman",
    category: "Thinking"
  },
  {
    sanskrit: "प्रश्नाः एव ज्ञानस्य द्वारम्।",
    hindi: "प्रश्न पूछना ज्ञान का द्वार खोलता है।",
    english: "Questions are the doorway to knowledge.",
    author: "C. V. Raman",
    category: "Learning"
  },
  {
    sanskrit: "आत्मबलं एव विजयम्।",
    hindi: "आत्मबल ही असली विजय है।",
    english: "Inner strength alone is true victory.",
    author: "Sister Nivedita",
    category: "Strength"
  },
  {
    sanskrit: "स्नेहेन शिक्षा दीयते।",
    hindi: "शिक्षा प्रेम से दी जाती है, दंड से नहीं।",
    english: "True education is given with love, never with fear.",
    author: "Rabindranath Tagore",
    category: "Teaching"
  },
  {
    sanskrit: "आत्मनिर्भरता एव स्वतंत्रता।",
    hindi: "आत्मनिर्भरता ही असली स्वतंत्रता है।",
    english: "Self-reliance is true freedom.",
    author: "Mahatma Gandhi",
    category: "Freedom"
  },
  {
    sanskrit: "गुणाः पूज्यन्ते न लिङ्गम्।",
    hindi: "गुण पूजे जाते हैं, न कि लिंग।",
    english: "Virtues, not gender, deserve respect.",
    author: "Sanskrit adage",
    category: "Equality"
  },
  {
    sanskrit: "अध्ययनम् एव तपः।",
    hindi: "पढ़ाई करना ही असली तपस्या है।",
    english: "Study itself is a form of penance.",
    author: "Sanskrit adage",
    category: "Study"
  },
  {
    sanskrit: "शिक्षक: राष्ट्रस्य निर्मात्रिः।",
    hindi: "शिक्षक ही राष्ट्र का निर्माता है।",
    english: "Teachers are the makers of a nation.",
    author: "Dr. Sarvepalli Radhakrishnan",
    category: "Teachers"
  },
  {
    sanskrit: "बालानां हृदयं मन्दिरं भवति।",
    hindi: "बच्चे का हृदय एक मन्दिर है।",
    english: "A child's heart is a sacred temple.",
    author: "Rabindranath Tagore",
    category: "Children"
  },
  {
    sanskrit: "मातृभूमिः स्वर्गादपि गरीयसी।",
    hindi: "जननी और जन्मभूमि स्वर्ग से भी बड़ी हैं।",
    english: "Mother and motherland are greater than heaven itself.",
    author: "Valmiki Ramayana",
    category: "Motherland"
  },

  // --- Expansion Set 1: Ancient Wisdom & Vedic Insights ---
  { sanskrit: "यत्र नार्यस्तु पूज्यन्ते रमन्ते तत्र देवताः।", hindi: "जहाँ नारी का सम्मान होता है, वहाँ देवता निवास करते हैं।", english: "Where women are honoured, there dwell the gods.", author: "Manu Smriti", category: "Women" },
  { sanskrit: "सर्वे भवन्तु सुखिनः सर्वे सन्तु निरामयाः।", hindi: "सब सुखी हों, सब निरोगी हों।", english: "May all be happy, may all be free from disease.", author: "Brihadaranyaka Upanishad", category: "Peace" },
  { sanskrit: "आत्मनो मोक्षार्थं जगद्धिताय च।", hindi: "आत्म-मुक्ति और जगत के कल्याण के लिए।", english: "For self-liberation and the welfare of the world.", author: "Swami Vivekananda", category: "Service" },
  { sanskrit: "उद्यमेन हि सिध्यन्ति कार्याणि न मनोरथैः।", hindi: "काम मेहनत से बनते हैं, केवल इच्छा से नहीं।", english: "Work is accomplished by effort, not by mere wishing.", author: "Hitopadesha", category: "Effort" },
  { sanskrit: "सुखार्थिनः कुतो विद्या नास्ति विद्यार्थिनः सुखम्।", hindi: "जो सुख चाहता है वह विद्या नहीं पा सकता; जो विद्या चाहता है उसे सुख नहीं।", english: "The pleasure-seeker gets no knowledge; the knowledge-seeker forgoes comfort.", author: "Chanakya Niti", category: "Learning" },
  { sanskrit: "अन्नं ब्रह्म रसं विष्णुः भोक्ता देवो महेश्वरः।", hindi: "अन्न ब्रह्म है, स्वाद विष्णु है, भोक्ता स्वयं शिव हैं।", english: "Food is Brahma, its taste Vishnu, and the one who eats is Shiva himself.", author: "Bhavishya Purana", category: "Gratitude" },
  { sanskrit: "बुद्धिर्यस्य बलं तस्य निर्बुद्धेस्तु कुतो बलम्।", hindi: "जिसके पास बुद्धि है वही बलवान है।", english: "One with wisdom is truly strong; how can the foolish be strong?", author: "Panchatantra", category: "Wisdom" },
  { sanskrit: "क्षमा वीरस्य भूषणम्।", hindi: "क्षमा वीर का आभूषण है।", english: "Forgiveness is the ornament of the brave.", author: "Subhashita", category: "Forgiveness" },
  { sanskrit: "अलसस्य कुतो विद्या।", hindi: "आलसी को विद्या कैसे मिले?", english: "How can a lazy person gain knowledge?", author: "Subhashita", category: "Discipline" },
  { sanskrit: "गुरुर्ब्रह्मा गुरुर्विष्णुः गुरुर्देवो महेश्वरः।", hindi: "गुरु ही ब्रह्मा, विष्णु और महेश्वर हैं।", english: "The Guru is Brahma, Vishnu and Maheshwara.", author: "Guru Stotra", category: "Teachers" },
  { sanskrit: "प्रारभ्यते न खलु विघ्नभयेन नीचैः।", hindi: "नीच लोग विघ्नों के डर से काम शुरू ही नहीं करते।", english: "The lowly never even begin, fearing obstacles.", author: "Bhartrhari Niti Shatakam", category: "Courage" },
  { sanskrit: "यथा राजा तथा प्रजा।", hindi: "जैसा राजा वैसी प्रजा।", english: "As the king, so the subjects.", author: "Chanakya Niti", category: "Leadership" },
  { sanskrit: "अल्पविद्या भयंकरी।", hindi: "अधूरा ज्ञान खतरनाक होता है।", english: "A little knowledge is a dangerous thing.", author: "Subhashita", category: "Learning" },
  { sanskrit: "स्वदेशे पूज्यते राजा विद्वान्‌ सर्वत्र पूज्यते।", hindi: "राजा अपने देश में पूजा जाता है; विद्वान सर्वत्र पूजा जाता है।", english: "A king is honoured in his land; a scholar is honoured everywhere.", author: "Chanakya Niti", category: "Learning" },
  { sanskrit: "पिता स्वर्गः पिता धर्मः पिता हि परमं तपः।", hindi: "पिता ही स्वर्ग हैं, पिता ही धर्म, पिता ही सर्वोच्च तप।", english: "Father is heaven, father is dharma, father is the highest penance.", author: "Mahabharata", category: "Family" },
  { sanskrit: "मातृदेवो भव पितृदेवो भव।", hindi: "माता को देव मानो, पिता को देव मानो।", english: "Revere your mother as God, revere your father as God.", author: "Taittiriya Upanishad", category: "Family" },
  { sanskrit: "अतिथिदेवो भव आचार्यदेवो भव।", hindi: "अतिथि को देव मानो, आचार्य को देव मानो।", english: "Revere the guest as God, revere the teacher as God.", author: "Taittiriya Upanishad", category: "Respect" },
  { sanskrit: "ईशावास्यमिदं सर्वं यत्किञ्च जगत्यां जगत्।", hindi: "इस संसार में जो भी है, सब ईश्वर से भरा है।", english: "All this, whatever is in this universe, is pervaded by the Divine.", author: "Isha Upanishad", category: "Devotion" },
  { sanskrit: "सत्यम् वद धर्मम् चर।", hindi: "सत्य बोलो, धर्म का पालन करो।", english: "Speak the truth, practise righteousness.", author: "Taittiriya Upanishad", category: "Truth" },
  { sanskrit: "अयं निजः परो वेति गणना लघुचेतसाम्।", hindi: "'यह अपना, यह पराया' सोच छोटे मन वालों की है।", english: "Small-minded people say 'this is mine, that is theirs' — the wise see the whole world as one family.", author: "Maha Upanishad", category: "Unity" },

  // --- Expansion Set 2: Bhagavad Gita gems ---
  { sanskrit: "कर्मण्येवाधिकारस्ते मा फलेषु कदाचन।", hindi: "तुम्हारा अधिकार कर्म पर है, फल पर नहीं।", english: "You have the right to action, never to its fruits.", author: "Bhagavad Gita 2.47", category: "Karma" },
  { sanskrit: "योगः कर्मसु कौशलम्।", hindi: "योग कार्य की कुशलता है।", english: "Yoga is skill in action.", author: "Bhagavad Gita 2.50", category: "Yoga" },
  { sanskrit: "समत्वं योग उच्यते।", hindi: "समभाव ही योग है।", english: "Equanimity is called yoga.", author: "Bhagavad Gita 2.48", category: "Yoga" },
  { sanskrit: "श्रद्धावान् लभते ज्ञानम्।", hindi: "जिसमें श्रद्धा है, वही ज्ञान पाता है।", english: "The one with faith attains knowledge.", author: "Bhagavad Gita 4.39", category: "Faith" },
  { sanskrit: "उद्धरेदात्मनात्मानम्।", hindi: "अपने आप से अपना उद्धार करो।", english: "One must uplift oneself by one's own self.", author: "Bhagavad Gita 6.5", category: "Self-Reliance" },
  { sanskrit: "अभ्यासेन तु कौन्तेय वैराग्येण च गृह्यते।", hindi: "अभ्यास और वैराग्य से मन को साधा जाता है।", english: "Through practice and detachment, the mind is mastered.", author: "Bhagavad Gita 6.35", category: "Discipline" },
  { sanskrit: "श्रेयान् स्वधर्मो विगुणः परधर्मात्स्वनुष्ठितात्।", hindi: "अपना दोषपूर्ण धर्म भी दूसरे के पूर्ण धर्म से श्रेष्ठ है।", english: "Better one's own duty imperfect than another's well-performed.", author: "Bhagavad Gita 3.35", category: "Duty" },
  { sanskrit: "यदा यदा हि धर्मस्य ग्लानिर्भवति भारत।", hindi: "जब-जब धर्म की हानि होती है, तब-तब मैं अवतरित होता हूँ।", english: "Whenever righteousness declines, I incarnate.", author: "Bhagavad Gita 4.7", category: "Dharma" },
  { sanskrit: "सर्वधर्मान्परित्यज्य मामेकं शरणं व्रज।", hindi: "सभी धर्मों को छोड़कर एक मेरी शरण में आओ।", english: "Abandon all dharmas and take refuge in Me alone.", author: "Bhagavad Gita 18.66", category: "Surrender" },
  { sanskrit: "मन एव मनुष्याणां कारणं बन्धमोक्षयोः।", hindi: "मन ही मनुष्य के बंधन और मोक्ष का कारण है।", english: "The mind alone is the cause of bondage and liberation.", author: "Amritabindu Upanishad", category: "Mind" },
  { sanskrit: "यत्र योगेश्वरः कृष्णो यत्र पार्थो धनुर्धरः।", hindi: "जहाँ योगेश्वर कृष्ण हों और धनुर्धारी अर्जुन, वहीं विजय है।", english: "Where there is Krishna and the archer Arjuna, there is victory.", author: "Bhagavad Gita 18.78", category: "Victory" },
  { sanskrit: "सुखदुःखे समे कृत्वा लाभालाभौ जयाजयौ।", hindi: "सुख-दुख, लाभ-हानि, जय-पराजय को समान समझो।", english: "Treat happiness and sorrow, gain and loss, victory and defeat as equal.", author: "Bhagavad Gita 2.38", category: "Equanimity" },
  { sanskrit: "यो न हृष्यति न द्वेष्टि न शोचति न काङ्क्षति।", hindi: "जो न हर्ष करता है, न द्वेष, न शोक, न इच्छा — वही प्रिय है।", english: "One who neither rejoices nor hates, grieves nor desires, is dear.", author: "Bhagavad Gita 12.17", category: "Detachment" },
  { sanskrit: "आपूर्यमाणमचलप्रतिष्ठं समुद्रमापः प्रविशन्ति यद्वत्।", hindi: "जैसे नदियाँ समुद्र में समा जाती हैं और समुद्र स्थिर रहता है, वैसे ज्ञानी।", english: "Like rivers merge into the still ocean, the wise remain unmoved.", author: "Bhagavad Gita 2.70", category: "Peace" },
  { sanskrit: "ध्यायतो विषयान्पुंसः सङ्गस्तेषूपजायते।", hindi: "विषयों का चिंतन करने से आसक्ति पैदा होती है।", english: "Dwelling on objects breeds attachment to them.", author: "Bhagavad Gita 2.62", category: "Discipline" },

  // --- Expansion Set 3: Chanakya Niti ---
  { sanskrit: "पुस्तकस्था तु या विद्या परहस्तगतं धनम्।", hindi: "पुस्तक में रखी विद्या और दूसरे के हाथ में गया धन — दोनों समय पर काम नहीं आते।", english: "Knowledge in books and wealth in others' hands are useless when needed.", author: "Chanakya Niti", category: "Learning" },
  { sanskrit: "समाने शोभते प्रीतिः राज्ञि सेवा च शोभते।", hindi: "समान लोगों में प्रेम शोभता है, राजा की सेवा शोभा देती है।", english: "Love blossoms among equals; service adorns the king.", author: "Chanakya Niti", category: "Relationships" },
  { sanskrit: "आपदर्थे धनं रक्षेत् दारान् रक्षेद्धनैरपि।", hindi: "आपत्ति के लिए धन बचाओ, धन से पत्नी की रक्षा करो, पर धर्म की रक्षा दोनों से करो।", english: "Save wealth for adversity, protect family with wealth, but protect dharma above all.", author: "Chanakya Niti", category: "Wisdom" },
  { sanskrit: "अत्यन्त कोपः कटु भाषणं च दरिद्रता च स्वजनेषु वैरम्।", hindi: "अत्यधिक क्रोध, कठोर वचन, दरिद्रता, और स्वजनों से वैर — ये नरक के लक्षण हैं।", english: "Excessive anger, harsh speech, poverty, and enmity with kin — these are signs of hell.", author: "Chanakya Niti", category: "Character" },
  { sanskrit: "शैले शैले न माणिक्यं मौक्तिकं न गजे गजे।", hindi: "हर पर्वत पर माणिक्य नहीं मिलता, हर हाथी में मोती नहीं होता।", english: "Every mountain has no gems, every elephant has no pearls — rare are the truly great.", author: "Chanakya Niti", category: "Rarity" },
  { sanskrit: "सर्वं परवशं दुःखं सर्वमात्मवशं सुखम्।", hindi: "पराधीनता में सब कुछ दुख है, स्वाधीनता में सब कुछ सुख।", english: "All that depends on others is misery; all that depends on the self is joy.", author: "Chanakya Niti", category: "Freedom" },
  { sanskrit: "काकचेष्टा बकोध्यानं श्वाननिद्रा तथैव च।", hindi: "विद्यार्थी में हो कौवे जैसी सतर्कता, बगुले जैसा ध्यान, कुत्ते जैसी हल्की नींद।", english: "A student must have the alertness of a crow, focus of a heron, and light sleep of a dog.", author: "Chanakya Niti", category: "Learning" },
  { sanskrit: "मूर्खस्तु परिहर्तव्यः प्रत्यक्षो द्विपदः पशुः।", hindi: "मूर्ख से दूर रहो; वह दिखने में मनुष्य पर होता है दो पैर वाला पशु।", english: "Avoid a fool — he is but a two-legged beast in human form.", author: "Chanakya Niti", category: "Wisdom" },
  { sanskrit: "अल्पानाम् अपि वस्तूनां संहतिः कार्यसाधिका।", hindi: "छोटी-छोटी चीजें भी मिल जायें तो बड़ा काम कर देती हैं।", english: "Even tiny things, when united, achieve great tasks.", author: "Hitopadesha", category: "Unity" },
  { sanskrit: "आयुषः क्षण एकोऽपि न लभ्यः स्वर्णकोटिभिः।", hindi: "जीवन का एक क्षण भी करोड़ों स्वर्ण से नहीं मिलता।", english: "A single moment of life cannot be bought with crores of gold.", author: "Chanakya Niti", category: "Time" },
  { sanskrit: "मूर्खा यत्र न पूज्यन्ते धान्यं यत्र सुसञ्चितम्।", hindi: "जहाँ मूर्खों की पूजा न हो, अन्न भंडार भरा हो, वहीं वास करना चाहिए।", english: "Live where fools are not worshipped and granaries are full.", author: "Chanakya Niti", category: "Wisdom" },
  { sanskrit: "आपः पिबन्तिन नद्यो न फलं भक्षयन्ति वृक्षाः।", hindi: "नदियाँ अपना जल नहीं पीतीं, पेड़ अपने फल नहीं खाते — यही परोपकार है।", english: "Rivers don't drink their water, trees don't eat their fruit — such is selfless service.", author: "Vrikshayurveda", category: "Service" },

  // --- Expansion Set 4: Modern Bharatiya Leaders ---
  { sanskrit: "स्वप्नः सत्यत्वं याति यदा तत्र कार्यं मिलति।", hindi: "जब मेहनत मिल जाए, तब सपने सच होते हैं।", english: "Dreams come true when work meets them.", author: "Dr. A.P.J. Abdul Kalam", category: "Dreams" },
  { sanskrit: "स्वयं दीपः स्वयं भव।", hindi: "स्वयं ही अपना दीपक बनो।", english: "Be a light unto yourself.", author: "Gautama Buddha", category: "Self-Reliance" },
  { sanskrit: "कर्तव्यमेव कर्म।", hindi: "जो करना चाहिए, वही कर्म है।", english: "Duty alone is action.", author: "Lokmanya Tilak", category: "Duty" },
  { sanskrit: "स्वदेशप्रेम एव देवसेवा।", hindi: "देश-प्रेम ही सबसे बड़ी देव-सेवा है।", english: "Love for one's country is the highest worship.", author: "Bankim Chandra", category: "Motherland" },
  { sanskrit: "आत्मबलं परमं बलम्।", hindi: "आत्मविश्वास सबसे बड़ा बल है।", english: "Self-confidence is the greatest strength.", author: "Swami Vivekananda", category: "Confidence" },
  { sanskrit: "यौवनं जीवनं सत्कर्मणा।", hindi: "यौवन का सच्चा जीवन सत्कर्म में है।", english: "Youth truly lives when it does good deeds.", author: "Swami Vivekananda", category: "Youth" },
  { sanskrit: "क्रान्तिः न रक्तेन, हृदयेन उदेति।", hindi: "क्रांति खून से नहीं, दिल से आती है।", english: "Revolution rises from the heart, not from blood.", author: "Bhagat Singh", category: "Change" },
  { sanskrit: "सत्यमेव आयुधम्।", hindi: "सत्य ही सबसे बड़ा हथियार है।", english: "Truth alone is the weapon.", author: "Mahatma Gandhi", category: "Truth" },
  { sanskrit: "स्वच्छता ईश्वरनिकटस्थम्।", hindi: "स्वच्छता ईश्वर के निकट है।", english: "Cleanliness is next to godliness.", author: "Mahatma Gandhi", category: "Discipline" },
  { sanskrit: "अहिंसा प्रेम्णः चरम स्वरूपम्।", hindi: "अहिंसा प्रेम का उच्चतम रूप है।", english: "Non-violence is the highest form of love.", author: "Mahatma Gandhi", category: "Peace" },
  { sanskrit: "स्वराज्यं मम जन्मसिद्धं अधिकारः।", hindi: "स्वराज्य मेरा जन्मसिद्ध अधिकार है।", english: "Swaraj is my birthright.", author: "Lokmanya Tilak", category: "Freedom" },
  { sanskrit: "देशसेवैव नारायणसेवा।", hindi: "देश-सेवा ही नारायण-सेवा है।", english: "Service to the nation is service to God.", author: "Netaji Subhash Chandra Bose", category: "Service" },
  { sanskrit: "श्रमः एव विद्या।", hindi: "श्रम ही विद्या है।", english: "Labour itself is knowledge.", author: "Rabindranath Tagore", category: "Effort" },
  { sanskrit: "एकतायाः बलं अनन्तम्।", hindi: "एकता में अनंत शक्ति है।", english: "There is infinite power in unity.", author: "Sardar Vallabhbhai Patel", category: "Unity" },
  { sanskrit: "साहसं परमं दैवम्।", hindi: "साहस ही सबसे बड़ा दैवत है।", english: "Courage is the highest divinity.", author: "Chandrashekhar Azad", category: "Courage" },

  // --- Expansion Set 5: Kabir, Rahim, Tulsidas — Bhakti wisdom ---
  { sanskrit: "बुरा जो देखन मैं चला बुरा न मिलिया कोय।", hindi: "बुरे को खोजने चला, तो पाया कि कोई बुरा नहीं है — जो देखा वह अपना ही दोष था।", english: "I searched for the wicked, but found none more wicked than myself.", author: "Sant Kabir", category: "Self-Reflection" },
  { sanskrit: "साँच बराबर तप नहीं झूठ बराबर पाप।", hindi: "सत्य के समान कोई तप नहीं, झूठ के समान कोई पाप नहीं।", english: "There is no penance like truth, no sin like a lie.", author: "Sant Kabir", category: "Truth" },
  { sanskrit: "पोथी पढ़ि पढ़ि जग मुआ पंडित भया न कोय।", hindi: "पोथी पढ़-पढ़कर पंडित नहीं बनते; प्रेम का एक अक्षर पढ़े वही पंडित है।", english: "The world reads books but no one becomes wise; one who reads a single letter of love is truly learned.", author: "Sant Kabir", category: "Learning" },
  { sanskrit: "ऐसी वाणी बोलिये मन का आपा खोय।", hindi: "ऐसी वाणी बोलो जो अपने और सुनने वाले दोनों को सुख दे।", english: "Speak such words that bring joy to yourself and to others.", author: "Sant Kabir", category: "Speech" },
  { sanskrit: "रहिमन धागा प्रेम का मत तोरो चटकाय।", hindi: "प्रेम का धागा एक बार टूटे तो जुड़े नहीं, जुड़े तो गाँठ पड़ जाए।", english: "Do not snap the thread of love; once broken, it cannot rejoin without a knot.", author: "Rahim", category: "Relationships" },
  { sanskrit: "बड़े बड़ाई ना करैं बड़े न बोलें बोल।", hindi: "बड़े लोग बड़ाई नहीं करते, बड़ी बातें नहीं कहते।", english: "The truly great never boast nor speak big words.", author: "Rahim", category: "Humility" },
  { sanskrit: "जो रहीम उत्तम प्रकृति का करि सकत कुसंग।", hindi: "उत्तम प्रकृति वाला कुसंग में भी नहीं बिगड़ता।", english: "One with a noble nature is not spoiled even by bad company.", author: "Rahim", category: "Character" },
  { sanskrit: "पर उपदेश कुशल बहुतेरे।", hindi: "दूसरों को उपदेश देने में सब कुशल हैं।", english: "Many are skilled at advising others.", author: "Tulsidas Ramcharitmanas", category: "Wisdom" },
  { sanskrit: "जाकि रही भावना जैसी। प्रभु मूरति देखी तिन तैसी।", hindi: "जिसकी जैसी भावना होती है, प्रभु उसी रूप में दिखते हैं।", english: "One sees the Lord in the form one's own heart holds.", author: "Tulsidas Ramcharitmanas", category: "Devotion" },
  { sanskrit: "करत करत अभ्यास के जड़मति होत सुजान।", hindi: "अभ्यास से जड़बुद्धि भी बुद्धिमान बन जाता है।", english: "Through constant practice, even the dullest mind grows wise.", author: "Vrindavan Das", category: "Practice" },
  { sanskrit: "जिन खोजा तिन पाइयाँ गहरे पानी पैठ।", hindi: "जो गहरे पानी में पैठा, उसी को मोती मिला।", english: "Only those who dive deep find the pearl.", author: "Sant Kabir", category: "Effort" },
  { sanskrit: "मन चंगा तो कठौती में गंगा।", hindi: "मन शुद्ध हो तो कठौती में भी गंगा है।", english: "If the heart is pure, even a small bowl is like the Ganga.", author: "Sant Ravidas", category: "Purity" },

  // --- Expansion Set 6: Nature, Time & Simplicity ---
  { sanskrit: "काल एव सर्वं जयति।", hindi: "समय ही सब कुछ जीतता है।", english: "Time conquers all.", author: "Mahabharata", category: "Time" },
  { sanskrit: "सूर्यः स्वकर्मणा नित्यम् उदेति।", hindi: "सूर्य अपने कर्म से नित्य उदित होता है।", english: "The sun rises every day through its own duty.", author: "Rig Veda", category: "Discipline" },
  { sanskrit: "वृक्षो हि परहिताय।", hindi: "वृक्ष केवल दूसरों के हित के लिए जीता है।", english: "A tree lives only for the good of others.", author: "Skanda Purana", category: "Service" },
  { sanskrit: "पर्यावरणं जीवनम्।", hindi: "पर्यावरण ही जीवन है।", english: "Environment itself is life.", author: "Atharva Veda", category: "Nature" },
  { sanskrit: "गंगा शुद्धिः जीवनस्य।", hindi: "गंगा जीवन की पवित्रता है।", english: "The Ganga is the purity of life.", author: "Skanda Purana", category: "Nature" },
  { sanskrit: "अल्पेच्छा महासुखम्।", hindi: "कम इच्छा में बड़ा सुख है।", english: "Great happiness lies in fewer desires.", author: "Bhartrhari Vairagya Shatakam", category: "Simplicity" },
  { sanskrit: "स्वल्पम् अपि सुसंस्कृतम्।", hindi: "थोड़ा भी अच्छा हो तो श्रेष्ठ है।", english: "Even a little, if refined, is great.", author: "Subhashita", category: "Quality" },
  { sanskrit: "मौनं सर्वार्थ साधनम्।", hindi: "मौन सारे कार्यों को सिद्ध करता है।", english: "Silence accomplishes all things.", author: "Subhashita", category: "Silence" },
  { sanskrit: "गच्छन् पिपीलिकोऽपि याति योजनम्।", hindi: "चलती हुई चींटी भी योजनों का सफर तय कर लेती है।", english: "Even an ant, if it keeps walking, crosses miles.", author: "Subhashita", category: "Perseverance" },
  { sanskrit: "आपः शीतलताप्रदाः पवमानाः जीवनदाः।", hindi: "जल शीतलता देता है, वायु जीवन देती है।", english: "Water gives coolness, air gives life.", author: "Rig Veda", category: "Nature" },
  { sanskrit: "पुष्पेषु मधु पुष्पस्थं भ्रमरः पिबति यत्नतः।", hindi: "जैसे भँवरा पुष्प से रस निकालता है, वैसे विद्यार्थी को ज्ञान लेना चाहिए।", english: "As the bee gathers nectar from flowers, a student must gather knowledge from all sources.", author: "Subhashita", category: "Learning" },
  { sanskrit: "फलं कालेन पच्यते।", hindi: "फल समय पर ही पकता है।", english: "Fruits ripen only in their time.", author: "Panchatantra", category: "Patience" },

  // --- Expansion Set 7: Family, Children, Motherhood ---
  { sanskrit: "जननी जन्मभूमिश्च स्वर्गादपि गरीयसी।", hindi: "जननी और जन्मभूमि स्वर्ग से बढ़कर हैं।", english: "Mother and motherland are greater than heaven.", author: "Valmiki Ramayana", category: "Motherland" },
  { sanskrit: "बालो हि जगतो अलंकारः।", hindi: "बच्चा ही संसार का सबसे बड़ा आभूषण है।", english: "A child is the greatest ornament of the world.", author: "Subhashita", category: "Children" },
  { sanskrit: "स्नेहः सर्वेषु प्रधानम्।", hindi: "स्नेह सबसे प्रमुख है।", english: "Affection is supreme above all.", author: "Subhashita", category: "Love" },
  { sanskrit: "प्रथमो गुरुर्जनेता।", hindi: "जन्म देने वाले माता-पिता प्रथम गुरु हैं।", english: "Parents are the first teachers.", author: "Manu Smriti", category: "Teachers" },
  { sanskrit: "मातुर्देवो न विद्यते।", hindi: "माँ के समान कोई देवता नहीं।", english: "There is no divinity greater than a mother.", author: "Skanda Purana", category: "Family" },
  { sanskrit: "गृहिणी गृहमुच्यते।", hindi: "गृहिणी ही घर है।", english: "The homemaker herself is the home.", author: "Manu Smriti", category: "Family" },
  { sanskrit: "पुत्रं शिक्षय पञ्चवर्षे।", hindi: "पाँच साल की उम्र से बच्चे को शिक्षा दो।", english: "Begin teaching a child at age five.", author: "Chanakya Niti", category: "Children" },
  { sanskrit: "लालयेत् पञ्चवर्षाणि दश वर्षाणि ताडयेत्।", hindi: "पाँच वर्ष तक लाड़-प्यार, दस वर्ष तक अनुशासन, फिर मित्रवत् व्यवहार।", english: "Pamper till five, discipline till ten, then treat as a friend.", author: "Chanakya Niti", category: "Parenting" },
  { sanskrit: "स्वागत सर्वे भवन्तु सुखिनः।", hindi: "स्वागत है — सब सुखी हों।", english: "Welcome — may everyone be happy.", author: "Vedic prayer", category: "Blessing" },
  { sanskrit: "यत्र नारी तत्र लक्ष्मी।", hindi: "जहाँ नारी है वहीं लक्ष्मी है।", english: "Where there is a woman, there is prosperity.", author: "Subhashita", category: "Women" },

  // --- Expansion Set 8: Character & Values ---
  { sanskrit: "शीलं परं भूषणम्।", hindi: "शील ही सबसे बड़ा आभूषण है।", english: "Character is the greatest ornament.", author: "Subhashita", category: "Character" },
  { sanskrit: "दानं दरिद्रस्य मुख्यं तपः।", hindi: "गरीब का दान सबसे बड़ा तप है।", english: "Charity by the poor is the greatest penance.", author: "Bhartrhari", category: "Charity" },
  { sanskrit: "विनयः शीलमूलं गुणः।", hindi: "विनम्रता शील का मूल गुण है।", english: "Humility is the root of all virtues.", author: "Subhashita", category: "Humility" },
  { sanskrit: "अहंकारः विनाशकारकः।", hindi: "अहंकार विनाश का कारण है।", english: "Ego brings about destruction.", author: "Panchatantra", category: "Humility" },
  { sanskrit: "दुष्टेषु मैत्री कदाचिन्न कर्तव्या।", hindi: "दुष्टों से कभी मित्रता नहीं करनी चाहिए।", english: "Never befriend the wicked.", author: "Hitopadesha", category: "Friendship" },
  { sanskrit: "उत्तमेन सह संगमः।", hindi: "श्रेष्ठों के साथ का संग सुख देता है।", english: "Company of the noble brings joy.", author: "Bhartrhari", category: "Friendship" },
  { sanskrit: "साधोः संगः महाभाग्यम्।", hindi: "साधु का संग बड़ा भाग्य है।", english: "The company of the pure-hearted is great fortune.", author: "Bhagavad Gita", category: "Association" },
  { sanskrit: "क्रोधात् भवति सम्मोहः।", hindi: "क्रोध से भ्रम, भ्रम से बुद्धि-नाश होता है।", english: "From anger comes delusion, from delusion loss of reason.", author: "Bhagavad Gita 2.63", category: "Anger" },
  { sanskrit: "लोभः पापस्य कारणम्।", hindi: "लोभ ही सारे पापों का कारण है।", english: "Greed is the root of all sin.", author: "Mahabharata", category: "Character" },
  { sanskrit: "धैर्यम् आपत्सु शोभनम्।", hindi: "आपत्ति में धैर्य ही शोभा है।", english: "Patience shines during hardships.", author: "Subhashita", category: "Patience" },
  { sanskrit: "सत्संगत्वे निःसंगत्वम्।", hindi: "सत्संग से आसक्ति टूटती है।", english: "In good company, attachments dissolve.", author: "Adi Shankaracharya", category: "Association" },
  { sanskrit: "उदारचरितानां तु वसुधैव कुटुम्बकम्।", hindi: "उदार लोगों के लिए तो पूरी पृथ्वी ही परिवार है।", english: "For the large-hearted, the world itself is family.", author: "Panchatantra", category: "Unity" },
  { sanskrit: "अलसाः न कदाचित् सिद्धिं प्राप्नुवन्ति।", hindi: "आलसी कभी सफल नहीं होते।", english: "The lazy never achieve success.", author: "Subhashita", category: "Effort" },
  { sanskrit: "श्रमेण सह हस्ते लक्ष्मीः।", hindi: "मेहनत के हाथ में ही लक्ष्मी है।", english: "Fortune rests in the hands that toil.", author: "Subhashita", category: "Effort" },
  { sanskrit: "शत्रोरपि गुणा वाच्याः दोषा वाच्याः गुरोरपि।", hindi: "शत्रु के गुण भी बोलो और गुरु के दोष भी बोलो।", english: "Speak the virtues of enemies and the faults of gurus — be fearless in truth.", author: "Chanakya Niti", category: "Truth" },
  { sanskrit: "प्रियं ब्रूयात् सत्यं ब्रूयात् न ब्रूयात् सत्यमप्रियम्।", hindi: "प्रिय बोलो, सत्य बोलो, पर अप्रिय सत्य मत बोलो।", english: "Speak pleasantly, speak truthfully, but do not speak an unpleasant truth.", author: "Manu Smriti", category: "Speech" },
  { sanskrit: "सर्वे गुणाः काञ्चनमाश्रयन्ति।", hindi: "सारे गुण धनवान में आ जाते हैं (लोगों की धारणा में)।", english: "In the world's eyes, all virtues seem to gather in wealth.", author: "Chanakya Niti", category: "Wisdom" },
  { sanskrit: "श्रद्धाहीनं तपः शून्यम्।", hindi: "श्रद्धा के बिना तप व्यर्थ है।", english: "Penance without faith is worthless.", author: "Bhagavad Gita 17.28", category: "Faith" },

  // --- Expansion Set 9: Yoga, Health & Body ---
  { sanskrit: "शरीरमाद्यं खलु धर्मसाधनम्।", hindi: "शरीर ही धर्म का प्रथम साधन है।", english: "The body is the first instrument of dharma.", author: "Kalidasa", category: "Health" },
  { sanskrit: "अभ्यासः सिद्धि हेतुः।", hindi: "अभ्यास सिद्धि का कारण है।", english: "Practice is the cause of success.", author: "Patanjali Yoga Sutras", category: "Practice" },
  { sanskrit: "स्थिरसुखमासनम्।", hindi: "आसन वह है जो स्थिर और सुखद हो।", english: "Posture should be steady and comfortable.", author: "Patanjali Yoga Sutra 2.46", category: "Yoga" },
  { sanskrit: "योगश्चित्तवृत्तिनिरोधः।", hindi: "योग चित्त की वृत्तियों का निरोध है।", english: "Yoga is the stilling of the fluctuations of the mind.", author: "Patanjali Yoga Sutra 1.2", category: "Yoga" },
  { sanskrit: "प्राणायामेन युक्तेन आयुर्वृद्धिः।", hindi: "युक्त प्राणायाम से आयु बढ़ती है।", english: "Regulated pranayama lengthens life.", author: "Hatha Yoga Pradipika", category: "Yoga" },
  { sanskrit: "अन्नमयं मनः।", hindi: "जैसा अन्न वैसा मन।", english: "The mind is made of the food we eat.", author: "Chandogya Upanishad", category: "Health" },
  { sanskrit: "मिताहारः महौषधम्।", hindi: "संयमित आहार ही सबसे बड़ी दवा है।", english: "Moderate eating is the greatest medicine.", author: "Ayurveda", category: "Health" },
  { sanskrit: "स्वास्थ्यं परमं धनम्।", hindi: "स्वास्थ्य सबसे बड़ा धन है।", english: "Health is the greatest wealth.", author: "Charaka Samhita", category: "Health" },
  { sanskrit: "व्यायामः शरीरस्य आनन्दप्रदः।", hindi: "व्यायाम शरीर को आनंद देता है।", english: "Exercise brings joy to the body.", author: "Sushruta Samhita", category: "Health" },
  { sanskrit: "निद्रा जीवनस्य आधारः।", hindi: "नींद जीवन का आधार है।", english: "Sleep is the foundation of life.", author: "Charaka Samhita", category: "Health" },

  // --- Expansion Set 10: Success, Perseverance, Effort ---
  { sanskrit: "प्रयत्नः सिद्धिं याति।", hindi: "प्रयत्न सफलता तक ले जाता है।", english: "Effort leads to success.", author: "Subhashita", category: "Success" },
  { sanskrit: "आरम्भ गुर्वी परिणामे तनुः।", hindi: "काम की शुरुआत में मेहनत बड़ी लगती है, बाद में हल्की।", english: "The start of a task feels heavy; it grows lighter with time.", author: "Kalidasa", category: "Perseverance" },
  { sanskrit: "मनसा चिन्तितं कार्यं दैवेन प्रत्यूह्यते।", hindi: "मन में सोचा कार्य भाग्य कभी विघ्न कर देता है, पर प्रयास मत छोड़ो।", english: "Fate sometimes disrupts our plans — never abandon effort.", author: "Subhashita", category: "Perseverance" },
  { sanskrit: "कर्म परं धर्मः।", hindi: "कर्म ही सबसे बड़ा धर्म है।", english: "Action itself is the greatest dharma.", author: "Bhagavad Gita", category: "Karma" },
  { sanskrit: "उत्थानेनैव सिद्धिः।", hindi: "उठकर चलने से ही सिद्धि होती है।", english: "Only by rising does one achieve.", author: "Manu Smriti", category: "Effort" },
  { sanskrit: "प्रयासं करोतु जनः फलं दास्यति ईश्वरः।", hindi: "मनुष्य प्रयास करे, फल ईश्वर देगा।", english: "Let humans strive — the Divine will grant the fruit.", author: "Subhashita", category: "Faith" },
  { sanskrit: "जय पराजयौ समः।", hindi: "जय-पराजय में समान भाव।", english: "Equal in victory and defeat.", author: "Bhagavad Gita", category: "Equanimity" },
  { sanskrit: "साहसे श्रीः प्रतिवसति।", hindi: "साहस में लक्ष्मी निवास करती है।", english: "Fortune dwells in courage.", author: "Panchatantra", category: "Courage" },
  { sanskrit: "उद्यमः खलु सिद्धिकारकः।", hindi: "उद्यम ही सिद्धि का दाता है।", english: "Enterprise is the cause of success.", author: "Chanakya Niti", category: "Effort" },
  { sanskrit: "उठो, जागो और लक्ष्य तक पहुँचो।", hindi: "उठो, जागो, और लक्ष्य प्राप्ति तक मत रुको।", english: "Arise, awake, and stop not till the goal is reached.", author: "Katha Upanishad / Vivekananda", category: "Effort" },
  { sanskrit: "श्रमप्राप्तं धनं धर्ममयम्।", hindi: "मेहनत से कमाया धन ही धर्ममय है।", english: "Wealth earned by labour alone is righteous.", author: "Manu Smriti", category: "Dharma" },

  // --- Expansion Set 11: Speech, Silence & Communication ---
  { sanskrit: "मौनं सुन्दरम्।", hindi: "मौन सुंदर है।", english: "Silence is beautiful.", author: "Bhartrhari", category: "Silence" },
  { sanskrit: "वाचि मधुरता चित्ते नैर्मल्यं।", hindi: "वाणी में मधुरता, मन में निर्मलता।", english: "Sweetness in speech, purity in mind.", author: "Subhashita", category: "Speech" },
  { sanskrit: "वाग्दण्डो अस्ति सर्वेषु दण्डेषु दुःखदः।", hindi: "वाणी का चोट सबसे बड़ा चोट है।", english: "The wound of harsh words is the deepest of all.", author: "Manu Smriti", category: "Speech" },
  { sanskrit: "अल्पभाषी बुद्धिमान् जनः।", hindi: "थोड़ा बोलने वाला बुद्धिमान है।", english: "One who speaks little is wise.", author: "Chanakya Niti", category: "Speech" },
  { sanskrit: "अपशब्देन दूषितं जन्म।", hindi: "अपशब्दों से जीवन दूषित होता है।", english: "Life is defiled by ill words.", author: "Subhashita", category: "Speech" },
  { sanskrit: "श्रवणं मनुष्यस्य मुख्यं गुणः।", hindi: "अच्छे से सुनना मनुष्य का मुख्य गुण है।", english: "Attentive listening is a chief virtue.", author: "Yajur Veda", category: "Listening" },
  { sanskrit: "प्रश्नः बुद्धेः द्वारम्।", hindi: "प्रश्न ही बुद्धि का द्वार है।", english: "A question is the doorway to wisdom.", author: "Upanishad tradition", category: "Learning" },

  // --- Expansion Set 12: Compassion, Charity & Society ---
  { sanskrit: "करुणा एव धर्मः।", hindi: "करुणा ही सच्चा धर्म है।", english: "Compassion itself is dharma.", author: "Buddha", category: "Compassion" },
  { sanskrit: "दयाभूताम् धर्मः।", hindi: "प्राणियों पर दया ही धर्म है।", english: "Kindness to beings is dharma.", author: "Mahabharata", category: "Compassion" },
  { sanskrit: "यथा गच्छन्ति गजाः तथा पश्चात् मार्गं ददति।", hindi: "जैसे हाथी चलते हैं वैसे ही पीछे राह छोड़ जाते हैं।", english: "As elephants walk, they leave a path — let leaders make way for others.", author: "Subhashita", category: "Leadership" },
  { sanskrit: "जीवो जीवस्य जीवनम्।", hindi: "एक जीव दूसरे का सहारा है।", english: "Every being sustains another.", author: "Bhagavata Purana", category: "Interdependence" },
  { sanskrit: "अन्नदानं परं दानम्।", hindi: "अन्न दान सबसे बड़ा दान है।", english: "Giving food is the greatest charity.", author: "Skanda Purana", category: "Charity" },
  { sanskrit: "विद्यादानं महादानम्।", hindi: "विद्या-दान महादान है।", english: "Sharing knowledge is the greatest gift.", author: "Skanda Purana", category: "Charity" },
  { sanskrit: "जनहितं परमं धर्मः।", hindi: "जन-हित ही सबसे बड़ा धर्म है।", english: "The welfare of people is the highest duty.", author: "Manu Smriti", category: "Service" },
  { sanskrit: "अभयं परं दानम्।", hindi: "अभयदान सबसे बड़ा दान है।", english: "Granting fearlessness is the greatest gift.", author: "Mahabharata", category: "Charity" },
  { sanskrit: "अतिथिः देवः।", hindi: "अतिथि देव समान है।", english: "The guest is akin to God.", author: "Taittiriya Upanishad", category: "Hospitality" },
  { sanskrit: "देवा वै दानप्रियाः।", hindi: "देवता दान से प्रसन्न होते हैं।", english: "The gods are pleased with charity.", author: "Rig Veda", category: "Charity" },

  // --- Expansion Set 13: Learning & Growth for Little Learners ---
  { sanskrit: "क्षणं क्षणं शिक्षेत्।", hindi: "क्षण-क्षण सीखते रहो।", english: "Learn every moment.", author: "Subhashita", category: "Learning" },
  { sanskrit: "प्रश्नं पृच्छ न लज्जसे।", hindi: "प्रश्न पूछने में कभी शर्म मत करो।", english: "Never feel shy to ask a question.", author: "Chanakya Niti", category: "Learning" },
  { sanskrit: "ज्ञानं भारं सत्यज्ञानिनः न।", hindi: "ज्ञान बोझ नहीं होता, अज्ञान होता है।", english: "Knowledge is never a burden; ignorance is.", author: "Subhashita", category: "Learning" },
  { sanskrit: "बहुज्ञः सुखं जीवति।", hindi: "बहुत जानने वाला सुखी जीता है।", english: "One who knows much lives happily.", author: "Chanakya Niti", category: "Learning" },
  { sanskrit: "प्रश्नः विद्यायाः जननी।", hindi: "प्रश्न विद्या की माँ है।", english: "A question is the mother of knowledge.", author: "Upanishad tradition", category: "Learning" },
  { sanskrit: "स्वदेशगर्वः विद्यार्थिनं वृद्ध करोति।", hindi: "देश पर गर्व विद्यार्थी को बड़ा बनाता है।", english: "Pride in the nation elevates a student.", author: "Rabindranath Tagore", category: "Motherland" },
  { sanskrit: "बालबुद्धिः सर्वदा जिज्ञासा।", hindi: "बच्चों की बुद्धि सदा जिज्ञासु होती है।", english: "A child's mind is ever curious.", author: "Rabindranath Tagore", category: "Children" },
  { sanskrit: "प्रकृतिः सर्वेषां शिक्षिका।", hindi: "प्रकृति सबकी शिक्षिका है।", english: "Nature is a teacher to all.", author: "Vedic tradition", category: "Nature" },

  // --- Expansion Set 14: Bharatiya Pride & Culture ---
  { sanskrit: "भारतम् मम प्राणः।", hindi: "भारत मेरा प्राण है।", english: "Bharat is my very life.", author: "Bankim Chandra", category: "Motherland" },
  { sanskrit: "वन्दे मातरम्।", hindi: "मैं माँ भारती को प्रणाम करता हूँ।", english: "I bow to my Motherland.", author: "Bankim Chandra Chattopadhyay", category: "Motherland" },
  { sanskrit: "जय हिन्द।", hindi: "भारत की जय हो।", english: "Victory to India.", author: "Subhash Chandra Bose", category: "Motherland" },
  { sanskrit: "स्वदेशाभिमानं देवभक्तिः।", hindi: "देश-भक्ति ही देव-भक्ति है।", english: "Love for the nation is devotion to God.", author: "Sri Aurobindo", category: "Motherland" },
  { sanskrit: "संस्कृतिः राष्ट्रस्य आत्मा।", hindi: "संस्कृति राष्ट्र की आत्मा है।", english: "Culture is the soul of a nation.", author: "Sri Aurobindo", category: "Culture" },
  { sanskrit: "संस्कृतम् मातृभूता।", hindi: "संस्कृत सब भाषाओं की माता है।", english: "Sanskrit is the mother of languages.", author: "Max Muller", category: "Culture" },
  { sanskrit: "योगः भारतस्य उपहारः।", hindi: "योग भारत का विश्व को उपहार है।", english: "Yoga is Bharat's gift to the world.", author: "Modern saying", category: "Culture" },
  { sanskrit: "आयुर्वेदः प्राचीनं वैद्यशास्त्रम्।", hindi: "आयुर्वेद प्राचीन चिकित्सा-शास्त्र है।", english: "Ayurveda is Bharat's ancient healing science.", author: "Charaka Samhita", category: "Culture" },
  { sanskrit: "गंगा जीवनदायिनी।", hindi: "गंगा जीवन देने वाली है।", english: "The Ganga is the giver of life.", author: "Skanda Purana", category: "Culture" },
  { sanskrit: "हिमालयः तपोभूमिः।", hindi: "हिमालय तपस्या की भूमि है।", english: "The Himalayas are the land of penance.", author: "Skanda Purana", category: "Culture" },
  { sanskrit: "काशी विश्वनाथस्य नगरी।", hindi: "काशी विश्वनाथ की नगरी है।", english: "Kashi is the city of Vishwanath.", author: "Skanda Purana", category: "Culture" },

  // --- Expansion Set 15: Devotion & Divine ---
  { sanskrit: "सर्वं खलु इदं ब्रह्म।", hindi: "सब कुछ ब्रह्म ही है।", english: "All this is truly Brahman.", author: "Chandogya Upanishad", category: "Devotion" },
  { sanskrit: "तत्त्वमसि।", hindi: "तुम वही (परमात्मा) हो।", english: "That thou art.", author: "Chandogya Upanishad", category: "Devotion" },
  { sanskrit: "अहम् ब्रह्मास्मि।", hindi: "मैं ब्रह्म हूँ।", english: "I am Brahman.", author: "Brihadaranyaka Upanishad", category: "Devotion" },
  { sanskrit: "प्रज्ञानं ब्रह्म।", hindi: "प्रज्ञान ही ब्रह्म है।", english: "Consciousness is Brahman.", author: "Aitareya Upanishad", category: "Devotion" },
  { sanskrit: "ॐ शान्तिः शान्तिः शान्तिः।", hindi: "शांति, शांति, शांति।", english: "Peace, peace, peace.", author: "Upanishadic prayer", category: "Peace" },
  { sanskrit: "ॐ नमः शिवाय।", hindi: "शिव को नमस्कार।", english: "Salutations to Shiva.", author: "Panchakshari mantra", category: "Devotion" },
  { sanskrit: "श्रीराम जय राम जय जय राम।", hindi: "श्रीराम की जय हो।", english: "Glory to Lord Rama.", author: "Bhakti tradition", category: "Devotion" },
  { sanskrit: "गणपति बप्पा मोरया।", hindi: "गणपति महाराज की जय।", english: "Hail Lord Ganapati.", author: "Bhakti tradition", category: "Devotion" },
  { sanskrit: "जय जगदीश हरे।", hindi: "जगत के स्वामी की जय हो।", english: "Glory to the Lord of the Universe.", author: "Aarti tradition", category: "Devotion" },
  { sanskrit: "हरि ॐ तत् सत्।", hindi: "हरि ही परम सत्य है।", english: "Hari is the ultimate Truth.", author: "Bhagavad Gita 17.23", category: "Devotion" },
  { sanskrit: "आत्मनि आत्मानं पश्य।", hindi: "अपने भीतर ही अपने को देखो।", english: "See the Self within the self.", author: "Katha Upanishad", category: "Devotion" },
  { sanskrit: "पुष्पं पत्रम् फलम् तोयम् यो मे भक्त्या प्रयच्छति।", hindi: "जो भक्ति से पत्ता, फूल, फल या जल भी अर्पित करता है, मैं उसे स्वीकार करता हूँ।", english: "Whoever offers Me a leaf, flower, fruit, or water with devotion — I accept it.", author: "Bhagavad Gita 9.26", category: "Devotion" },

  // --- Expansion Set 16: Everyday little wisdom for children ---
  { sanskrit: "प्रातः उत्थानम् सुखदायकम्।", hindi: "सुबह जल्दी उठना सुखदायक है।", english: "Rising early brings joy.", author: "Ayurveda", category: "Discipline" },
  { sanskrit: "स्वयंकृतं कर्म शोभते।", hindi: "अपने हाथ से किया काम ही शोभा देता है।", english: "Work done with one's own hands shines brightest.", author: "Subhashita", category: "Effort" },
  { sanskrit: "हसन्तः जीवन्तु सर्वे।", hindi: "सब हँसते हुए जीयें।", english: "May all live smiling.", author: "Vedic prayer", category: "Joy" },
  { sanskrit: "मित्रता एव जीवनम्।", hindi: "मित्रता ही जीवन है।", english: "Friendship is life itself.", author: "Chanakya Niti", category: "Friendship" },
  { sanskrit: "साफल्यं परिश्रमे।", hindi: "सफलता मेहनत में है।", english: "Success lies in hard work.", author: "Subhashita", category: "Success" },
  { sanskrit: "स्वच्छता संस्कृतिः।", hindi: "स्वच्छता ही संस्कृति है।", english: "Cleanliness is culture.", author: "Modern saying", category: "Discipline" },
  { sanskrit: "प्रकृतिः देवः।", hindi: "प्रकृति देवता है।", english: "Nature is divine.", author: "Vedic tradition", category: "Nature" },
  { sanskrit: "पशुप्रेमः धार्मिकत्वम्।", hindi: "पशुओं से प्रेम धार्मिकता है।", english: "Love for animals is true religion.", author: "Buddha", category: "Compassion" },
  { sanskrit: "बालोऽपि सिंहशावको महामतः।", hindi: "छोटा शेर का बच्चा भी बड़ा माना जाता है।", english: "Even a small lion cub is respected — greatness is not in age.", author: "Subhashita", category: "Confidence" },
  { sanskrit: "समयस्य पालनं सिद्धिः।", hindi: "समय का पालन सफलता है।", english: "Punctuality is success.", author: "Modern saying", category: "Time" },
  { sanskrit: "पित्रोः आज्ञा शिरोधार्या।", hindi: "माता-पिता की आज्ञा सिर-आँखों पर।", english: "Parents' words are borne on the head.", author: "Manu Smriti", category: "Family" },
  { sanskrit: "गुरुर्ब्रह्मा।", hindi: "गुरु ही ब्रह्मा हैं।", english: "The teacher is the creator.", author: "Guru Stotra", category: "Teachers" },
  { sanskrit: "विनयः शोभा।", hindi: "विनय ही शोभा है।", english: "Modesty is beauty.", author: "Subhashita", category: "Humility" },

  // --- Expansion Set 17: Panchatantra bites ---
  { sanskrit: "एकतायाः शक्तिः महती।", hindi: "एकता में बड़ी शक्ति है।", english: "There is great strength in unity.", author: "Panchatantra", category: "Unity" },
  { sanskrit: "बुद्धिः वरं बलेन।", hindi: "बुद्धि बल से बड़ी है।", english: "Wisdom is greater than strength.", author: "Panchatantra", category: "Wisdom" },
  { sanskrit: "मित्रं गूढ़ं परीक्ष्य कुर्यात्।", hindi: "मित्र बनाने से पहले परख लेना चाहिए।", english: "Test before you trust a friend.", author: "Panchatantra", category: "Friendship" },
  { sanskrit: "आपत्तौ मित्रं परीक्षते।", hindi: "मित्र की परख विपत्ति में होती है।", english: "A friend is known in adversity.", author: "Panchatantra", category: "Friendship" },
  { sanskrit: "अल्पस्य क्रोधे महती हानिः।", hindi: "छोटी बात पर क्रोध बड़ी हानि करता है।", english: "Anger over small matters causes great loss.", author: "Panchatantra", category: "Anger" },
  { sanskrit: "मौर्ख्यं महाव्याधिः।", hindi: "मूर्खता महारोग है।", english: "Foolishness is a great disease.", author: "Panchatantra", category: "Wisdom" },
  { sanskrit: "समुद्रात् इव मणिः रत्नस्य दुर्लभा।", hindi: "समुद्र से मणि की तरह अच्छे मित्र भी दुर्लभ हैं।", english: "Like a gem from the sea, true friends are rare.", author: "Panchatantra", category: "Friendship" },
  { sanskrit: "स्वजना दैवं सहायकाः।", hindi: "अपने लोग भाग्य के सहायक हैं।", english: "Loved ones are the allies of fortune.", author: "Panchatantra", category: "Family" },
  { sanskrit: "मूर्ख: चिन्तां न मन्यते सत्यं वदति निर्भयम्।", hindi: "मूर्ख निर्भय होकर बोलता है, बुद्धिमान सोचकर।", english: "A fool speaks fearlessly; the wise speaks after thought.", author: "Panchatantra", category: "Speech" },
  { sanskrit: "समयः कोऽपि न याति व्यर्थम्।", hindi: "समय व्यर्थ नहीं जाना चाहिए।", english: "No moment should be wasted.", author: "Panchatantra", category: "Time" },

  // --- Expansion Set 18: Blessings & Prayers ---
  { sanskrit: "ॐ असतो मा सद्गमय।", hindi: "असत् से सत् की ओर ले चलो।", english: "Lead me from untruth to truth.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "तमसो मा ज्योतिर्गमय।", hindi: "अंधकार से प्रकाश की ओर ले चलो।", english: "Lead me from darkness to light.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "मृत्योर्मा अमृतं गमय।", hindi: "मृत्यु से अमरत्व की ओर ले चलो।", english: "Lead me from death to immortality.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "सर्वे भवन्तु सुखिनः।", hindi: "सब सुखी हों।", english: "May all be happy.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "सर्वे सन्तु निरामयाः।", hindi: "सब निरोगी हों।", english: "May all be free from illness.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "सर्वे भद्राणि पश्यन्तु।", hindi: "सब कल्याण के भागी हों।", english: "May all see auspiciousness.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "मा कश्चित् दुःखभाग्भवेत्।", hindi: "किसी को भी दुख न हो।", english: "May no one suffer.", author: "Brihadaranyaka Upanishad", category: "Prayer" },
  { sanskrit: "ॐ पूर्णमदः पूर्णमिदम्।", hindi: "यह पूर्ण है, वह भी पूर्ण है।", english: "That is whole, this is whole — from wholeness emerges wholeness.", author: "Isha Upanishad", category: "Prayer" },
  { sanskrit: "गायत्री महामंत्रो।", hindi: "ॐ भूर्भुवः स्वः — गायत्री मंत्र।", english: "Gayatri Mantra — awaken our intellect.", author: "Rig Veda", category: "Prayer" },
  { sanskrit: "ॐ त्र्यम्बकं यजामहे।", hindi: "त्र्यम्बक (शिव) को पूजते हैं।", english: "We worship the three-eyed Lord Shiva.", author: "Rig Veda", category: "Prayer" },
  { sanskrit: "गुरुर्देवो भव।", hindi: "गुरु को देव मानो।", english: "Revere the teacher as God.", author: "Taittiriya Upanishad", category: "Teachers" },

  // --- Final closer ---
  {
    sanskrit: "बालेषु सदा भव करुणा।",
    hindi: "बच्चों पर सदा करुणा रखो।",
    english: "May we always hold compassion for our little ones.",
    author: "Aadi Gayanam Prayer",
    category: "Children"
  }
];

// Get today's thought based on day of year
export const getThoughtOfTheDay = (date = new Date()) => {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = date - start;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  const index = (dayOfYear - 1 + 365) % thoughtsPool.length;
  return { ...thoughtsPool[index], dayOfYear };
};
